import React, { useState, useEffect } from "react";
import { Box, Grid, Icon, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, Switch, FormControlLabel, TablePagination, Select, Checkbox, Chip, InputLabel, Slider, Tooltip, Radio, Menu, Badge, Divider, ClickAwayListener, Button, TextField, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import FormField from "layouts/pages/users/new-user/components/FormField";
import { Form, Formik } from "formik";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import { get, postNoResponse, post, getFile, postUploadNoResponse } from "utils/WebService";
import moment from "moment";
import MDInput from "components/MDInput";
import MDSelect from "components/MDSelect";
import MDSnackbar from "components/MDSnackbar";
import { toCurrency } from "utils/NumberUtils";
import { useUser } from "context/UserContext";
import { useMaterialUIController } from "context";
import { useMinimizedWindows } from "context/MinimizedWindowsContext";

const formatCurrencyInput = (value) => {
    if (value === null || value === undefined || value === "") return "";
    let isNegative = value.toString().includes("-");
    if (typeof value === "number") {
        value = Math.abs(value).toFixed(2);
    }
    let numericValue = value.toString().replace(/\D/g, "");
    if (!numericValue) return "";
    numericValue = (numericValue / 100).toFixed(2) + "";
    numericValue = numericValue.replace(".", ",");
    numericValue = numericValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    return (isNegative ? "-R$ " : "R$ ") + numericValue;
};

const formatUncurrency = (value) => {
    if (value === null || value === undefined || value === "") return null;
    if (typeof value === 'number') return value;
    let isNegative = value.toString().includes("-");
    let cleanVal = value.toString().replace("-", "").replace("R$ ", "").trim();
    if (cleanVal.includes(",")) {
        cleanVal = cleanVal.replace(/\./g, "").replace(",", ".");
    }
    let num = parseFloat(cleanVal);
    return isNegative ? -num : num;
};

export default function Contratos({ formRef, recordId, idDevedorCarteira, idDevedorCarteiraRaw, selectedFicha, isViewOnly, pendingContratos = [], setPendingContratos, isHonorariosTab = false, changeTab, onDataUpdated, refreshKey, preloadedContratos, preloadedAcordos, preloadedDevedor, isFila = false }) {
    const isTerceiroFicha = Boolean(
        formRef?.current?.values?.idDevedorPai ||
        preloadedDevedor?.idDevedorPai ||
        preloadedDevedor?.nomeDevedorPai ||
        preloadedDevedor?.documentoDevedorPai
    );
    const { userPerfils, userFunctionalities } = useUser();
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { minimizeWindow, removeWindow } = useMinimizedWindows();
    const isAdminOrSuporte = userPerfils && userPerfils.some(p => {
        const t = typeof p === 'object' ? (p?.tipoPerfil ?? p?.cvTipo ?? p?.cvCodPerfil) : null;
        const n = (typeof p === 'object' ? (p?.nome || '') : String(p)).toLowerCase();
        return t === 4 || t === 6 || n.includes('admin') || n.includes('suporte');
    });
    const isDirectMigrateUser = userPerfils && userPerfils.some(p => {
        const t = typeof p === 'object' ? (p?.tipoPerfil ?? p?.cvTipo ?? p?.cvCodPerfil) : null;
        const n = (typeof p === 'object' ? (p?.nome || '') : String(p)).toLowerCase();
        return t === 1 || t === 4 || t === 6 || n.includes('admin') || n.includes('suporte') || n.includes('gestor');
    });
    const isFichaDevolvida = formRef?.current?.values?.status === 1;

    const [contratos, setContratos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isSavingForm, setIsSavingForm] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [marcacoes, setMarcacoes] = useState([]);
    const [selectedContrato, setSelectedContrato] = useState(null);
    const [apenasAtivos, setApenasAtivos] = useState(true);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [sbMessage, setSbMessage] = useState("");

    const [openDevolverModal, setOpenDevolverModal] = useState(false);
    const [devolverObs, setDevolverObs] = useState("");
    const [devolverFile, setDevolverFile] = useState(null);
    const [isSubmittingDevolucao, setIsSubmittingDevolucao] = useState(false);
    const [contratoParaDevolver, setContratoParaDevolver] = useState(null);
    const [confirmAction, setConfirmAction] = useState({ open: false, title: "", message: "", onConfirm: null });

    const [simulacaoOpen, setSimulacaoOpen] = useState(false);
    const [simulacaoMinimizada, setSimulacaoMinimizada] = useState(false);
    const [acordoMinimizado, setAcordoMinimizado] = useState(false);
    const [openExportCronogramaModal, setOpenExportCronogramaModal] = useState(false);
    const [exportDataPrimeiraParcela, setExportDataPrimeiraParcela] = useState("");
    const [simulacaoData, setSimulacaoData] = useState(null);
    const [simulacaoLoading, setSimulacaoLoading] = useState(false);
    const [dataBaseSimulacao, setDataBaseSimulacao] = useState(moment().format("YYYY-MM-DD"));

    const [reagruparModalOpen, setReagruparModalOpen] = useState(false);
    const [reagruparDestinoId, setReagruparDestinoId] = useState("");
    const [reagruparMoverTodos, setReagruparMoverTodos] = useState(true);
    const [reagruparMotivo, setReagruparMotivo] = useState("");
    const [isSubmittingReagrupamento, setIsSubmittingReagrupamento] = useState(false);
    const [fichasDisponiveis, setFichasDisponiveis] = useState([]);

    const [acordoModalOpen, setAcordoModalOpen] = useState(false);
    const [acordoOpcaoSelecionada, setAcordoOpcaoSelecionada] = useState(null);
    const [acordoQtdParcelas, setAcordoQtdParcelas] = useState(1);
    const [acordoPrimeiroVencimento, setAcordoPrimeiroVencimento] = useState(moment().add(30, 'days').format("YYYY-MM-DD"));
    const [acordoPeriodicidade, setAcordoPeriodicidade] = useState(30);
    const [acordoValorEntrada, setAcordoValorEntrada] = useState("");
    const [acordoQtdEntrada, setAcordoQtdEntrada] = useState(1);
    const [acordoVencimentoEntrada, setAcordoVencimentoEntrada] = useState(moment().format("YYYY-MM-DD"));
    const [acordoParcelasGeradas, setAcordoParcelasGeradas] = useState([]);
    const [cronogramaCalculado, setCronogramaCalculado] = useState(false);
    const [acordoEntradasDetalhadas, setAcordoEntradasDetalhadas] = useState([]);
    const [acordoMleList, setAcordoMleList] = useState([]);
    const [acordoComEntrada, setAcordoComEntrada] = useState(false);
    const [acordoIsExcecao, setAcordoIsExcecao] = useState(false);
    const [acordoFormaPagamento, setAcordoFormaPagamento] = useState("Boleto");
    const [acordoValorManual, setAcordoValorManual] = useState("");
    const [acordoLoading, setAcordoLoading] = useState(false);
    const [acordos, setAcordos] = useState([]);

    useEffect(() => {
        return () => {
            removeWindow(`simulacao-${recordId || "current"}`);
            removeWindow(`acordo-${recordId || "current"}`);
        };
    }, [recordId, removeWindow]);

    const handleMinimizarSimulacao = () => {
        setSimulacaoMinimizada(true);
        minimizeWindow({
            id: `simulacao-${recordId || "current"}`,
            title: "Simulação de Campanha",
            subtitle: simulacaoData?.devedorNome ? `Devedor: ${simulacaoData.devedorNome}` : "Cálculo de proposta",
            icon: "calculate",
            color: "#1A73E8",
            tabKey: isFila ? "fila-trabalho" : "baseDeDados",
            onRestore: () => {
                setSimulacaoMinimizada(false);
            },
            onClose: () => {
                setSimulacaoMinimizada(false);
                setSimulacaoOpen(false);
            }
        });
    };

    const handleMinimizarAcordo = () => {
        setAcordoMinimizado(true);
        minimizeWindow({
            id: `acordo-${recordId || "current"}`,
            title: "Negociação de Acordo",
            subtitle: simulacaoData?.devedorNome ? `Devedor: ${simulacaoData.devedorNome}` : "Cronograma de parcelas",
            icon: "handshake",
            color: "#4CAF50",
            tabKey: isFila ? "fila-trabalho" : "baseDeDados",
            onRestore: () => {
                setAcordoMinimizado(false);
            },
            onClose: () => {
                setAcordoMinimizado(false);
                setAcordoModalOpen(false);
            }
        });
    };

    // Honorários Configuration State
    const [gerarHO, setGerarHO] = useState(false);
    const [hoPercentual, setHoPercentual] = useState(20);
    const [hoTipo, setHoTipo] = useState(1);
    const hoTiposList = [
        { id: 1, label: 'Sucumbenciais' },
        { id: 2, label: 'Contratuais' },
        { id: 3, label: 'Iniciais' },
        { id: 4, label: 'Finais' },
        { id: 5, label: 'Outros' }
    ];

    const [confirmCancelOpen, setConfirmCancelOpen] = useState(false);
    const [pendingOpcao, setPendingOpcao] = useState(null);
    const [selectedContratos, setSelectedContratos] = useState([]);

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [contratoToDelete, setContratoToDelete] = useState(null);

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            setSelectedContratos(contratosFiltrados.map(c => c.id));
        } else {
            setSelectedContratos([]);
        }
    };

    const handleCheckboxClick = (event, id) => {
        event.stopPropagation();
        setSelectedContratos(prev =>
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const showSnackbar = (msg, isSuccess) => {
        setSbMessage(msg);
        if (isSuccess) setSuccessSB(true);
        else setErrorSB(true);
    };

    const fetchContratos = () => {
        if (!recordId) return;

        console.log("=== DEBUG CONTRATOS ===");
        console.log("preloadedContratos recebido:", preloadedContratos ? preloadedContratos.length : "null");
        console.log("idDevedorCarteira filtro:", idDevedorCarteira);
        console.log("isHonorariosTab:", isHonorariosTab);

        if (preloadedContratos !== undefined && preloadedAcordos !== undefined) {
            // Usa dados pré-carregados do componente pai!
            let resContratos = preloadedContratos || [];

            if (resContratos.length > 0) {
                console.log("Amostra IDs devedorCarteira originais:", JSON.stringify(resContratos.map(c => c.idDevedorCarteira)));
            }

            const isFichaHO = Boolean(isHonorariosTab || selectedFicha?.isHonorario === true || selectedFicha?.cbIsHonorario === true);

            if (isFichaHO) {
                resContratos = resContratos.filter(c => c.isHonorario === true || c.cbIsHonorario === true);
            } else {
                const isFilhoFicha = isTerceiroFicha || Boolean(preloadedDevedor?.idDevedorPai);
                resContratos = resContratos.filter(c =>
                    isFilhoFicha || c.isTerceiro === true || (c.isHonorario !== true && c.cbIsHonorario !== true)
                );
            }
            console.log("Após filtro isHonorario, sobrou:", resContratos.length);

            const filterContratosByCarteira = (list) => {
                if (!Array.isArray(list)) return [];
                const targetRaw = idDevedorCarteiraRaw != null 
                    ? String(idDevedorCarteiraRaw) 
                    : (selectedFicha?.rawId != null ? String(selectedFicha.rawId) : null);
                const targetEnc = idDevedorCarteira ? String(idDevedorCarteira) : (selectedFicha?.id ? String(selectedFicha.id) : null);

                if (!targetRaw && !targetEnc) return list;

                const hasAnyLinkedFicha = list.some(c => c.rawIdDevedorCarteira || c.idDevedorCarteira);

                return list.filter(c => {
                    const cRaw = c.rawIdDevedorCarteira != null ? String(c.rawIdDevedorCarteira) : null;
                    const cEnc = c.idDevedorCarteira != null ? String(c.idDevedorCarteira) : null;

                    if (targetRaw && (cRaw === targetRaw || cEnc === targetRaw)) return true;
                    if (targetEnc && (cEnc === targetEnc || cRaw === targetEnc)) return true;

                    if (!cRaw && !cEnc) {
                        if (selectedFicha) {
                            if (c.idCarteira && selectedFicha.idCarteira && String(c.idCarteira) === String(selectedFicha.idCarteira)) return true;
                            if (c.nomeCarteira && selectedFicha.nomeCarteira && c.nomeCarteira.trim().toLowerCase() === selectedFicha.nomeCarteira.trim().toLowerCase()) return true;
                        }
                        if (!hasAnyLinkedFicha) return true;
                    }
                    return false;
                });
            };

            resContratos = filterContratosByCarteira(resContratos);

            setContratos(resContratos);
            setAcordos(preloadedAcordos || []);
            return;
        }

        setLoading(true);
        Promise.all([
            get(`/contratos/list/${recordId}`),
            get(`/acordo/list/${recordId}`)
        ]).then(([contratosRes, acordosRes]) => {
            let resContratos = contratosRes || [];
            const isFichaHO = Boolean(isHonorariosTab || selectedFicha?.isHonorario === true || selectedFicha?.cbIsHonorario === true);

            if (isFichaHO) {
                resContratos = resContratos.filter(c => c.isHonorario === true || c.cbIsHonorario === true);
            } else {
                const isFilhoFicha = isTerceiroFicha || Boolean(preloadedDevedor?.idDevedorPai);
                resContratos = resContratos.filter(c =>
                    isFilhoFicha || c.isTerceiro === true || (c.isHonorario !== true && c.cbIsHonorario !== true)
                );
            }
            const filterContratosByCarteira = (list) => {
                if (!Array.isArray(list)) return [];
                const targetRaw = idDevedorCarteiraRaw != null 
                    ? String(idDevedorCarteiraRaw) 
                    : (selectedFicha?.rawId != null ? String(selectedFicha.rawId) : null);
                const targetEnc = idDevedorCarteira ? String(idDevedorCarteira) : (selectedFicha?.id ? String(selectedFicha.id) : null);

                if (!targetRaw && !targetEnc) return list;

                const hasAnyLinkedFicha = list.some(c => c.rawIdDevedorCarteira || c.idDevedorCarteira);

                return list.filter(c => {
                    const cRaw = c.rawIdDevedorCarteira != null ? String(c.rawIdDevedorCarteira) : null;
                    const cEnc = c.idDevedorCarteira != null ? String(c.idDevedorCarteira) : null;

                    if (targetRaw && (cRaw === targetRaw || cEnc === targetRaw)) return true;
                    if (targetEnc && (cEnc === targetEnc || cRaw === targetEnc)) return true;

                    if (!cRaw && !cEnc) {
                        if (selectedFicha) {
                            if (c.idCarteira && selectedFicha.idCarteira && String(c.idCarteira) === String(selectedFicha.idCarteira)) return true;
                            if (c.nomeCarteira && selectedFicha.nomeCarteira && c.nomeCarteira.trim().toLowerCase() === selectedFicha.nomeCarteira.trim().toLowerCase()) return true;
                        }
                        if (!hasAnyLinkedFicha) return true;
                    }
                    return false;
                });
            };
            resContratos = filterContratosByCarteira(resContratos);
            setContratos(resContratos);
            setAcordos(acordosRes || []);
        }).catch(() => {
            showSnackbar("Erro ao carregar contratos ou acordos", false);
        }).finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchContratos();
    }, [recordId, refreshKey, idDevedorCarteira, idDevedorCarteiraRaw, selectedFicha, preloadedContratos, preloadedAcordos, preloadedDevedor]);

    useEffect(() => {
        get("/marcacoes").then((res) => {
            const list = res.list || res.data || (Array.isArray(res) ? res : []);
            setMarcacoes(list.filter(m => m.cvAlvo === 2 || m.cvAlvo === 3));
        }).catch(() => setMarcacoes([]));
    }, [recordId, pendingContratos, refreshKey]);

    const invalidateCronograma = () => {
        setCronogramaCalculado(false);
        setAcordoParcelasGeradas([]);
    };

    const handleChangePrimeiroVencimento = (valStr) => {
        setAcordoPrimeiroVencimento(valStr);
        invalidateCronograma();
        if (!valStr || valStr.length < 10) return;

        let query = `dataBase=${valStr}`;
        if (selectedContratos.length > 0) {
            query += `&contratosIds=${selectedContratos.join(',')}`;
        } else {
            const allIds = contratos.map(c => c.id).join(',');
            query += `&contratosIds=${allIds}`;
        }

        get(`/campanha/simular-calculo-devedor/${recordId}?${query}`)
            .then(res => {
                setSimulacaoData(res);
                setAcordoOpcaoSelecionada(prev => {
                    if (!prev) return prev;
                    if (prev.isManual) {
                        setAcordoValorManual(formatCurrencyInput(res.totalAtualizado));
                        return { ...prev, totalComDesconto: res.totalAtualizado };
                    }
                    if (res.opcoesParcelamento) {
                        const newOption = res.opcoesParcelamento.find(o => o.parcelaMinima === prev.parcelaMinima && o.parcelaMaxima === prev.parcelaMaxima);
                        return newOption || prev;
                    }
                    return prev;
                });
            })
            .catch(err => {
                showSnackbar(err.message || "Erro ao re-simular com a nova data de vencimento.", false);
            });
    };

    const handleMainValorEntradaChange = (valStr) => {
        const formatted = formatCurrencyInput(valStr);
        setAcordoValorEntrada(formatted);
        invalidateCronograma();
        const val = formatUncurrency(formatted) || 0;
        const qty = parseInt(acordoQtdEntrada) || 0;
        if (qty > 0) {
            const valEach = val / qty;
            setAcordoEntradasDetalhadas(prev => {
                const list = [...prev];
                return list.map(item => ({
                    ...item,
                    valor: formatCurrencyInput(valEach)
                }));
            });
        }
    };

    useEffect(() => {
        if (!acordoComEntrada) {
            setAcordoEntradasDetalhadas([]);
            return;
        }
        const qty = parseInt(acordoQtdEntrada) || 0;
        if (qty <= 0) {
            setAcordoEntradasDetalhadas([]);
            return;
        }

        setAcordoEntradasDetalhadas(prev => {
            if (qty === 1) {
                const existingMle = prev[0]?.isMle || false;
                return [{
                    valor: acordoValorEntrada,
                    vencimento: acordoVencimentoEntrada,
                    isMle: existingMle
                }];
            } else {
                if (prev.length !== qty) {
                    const baseVal = formatUncurrency(acordoValorEntrada) || 0;
                    const valEach = qty > 0 ? baseVal / qty : 0;
                    const list = [];
                    let curVenc = moment(acordoVencimentoEntrada || undefined);
                    const period = parseInt(acordoPeriodicidade) || 30;

                    for (let i = 0; i < qty; i++) {
                        if (prev[i]) {
                            list.push(prev[i]);
                        } else {
                            list.push({
                                valor: formatCurrencyInput(valEach),
                                vencimento: curVenc.format("YYYY-MM-DD"),
                                isMle: false
                            });
                        }
                        curVenc.add(period, 'days');
                    }
                    return list;
                }
                return prev;
            }
        });
    }, [acordoComEntrada, acordoQtdEntrada, acordoValorEntrada, acordoVencimentoEntrada, acordoPeriodicidade]);

    const handleOpenDialog = (contrato = null) => {
        setSelectedContrato(contrato);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setSelectedContrato(null);
        setOpenDialog(false);
    };

    const handleSubmit = (values, { setSubmitting }) => {
        const payload = {
            id: values.id,
            idDevedor: recordId,
            titulo: values.titulo,
            descricao: values.descricao,
            parcela: values.parcela,
            vencimento: values.vencimento,
            valorOriginal: formatUncurrency(values.valorOriginal),
            saldo: formatUncurrency(values.saldo),
            situacao: values.situacao,
            marcacoesIds: values.marcacoesIds,
            idCarteira: values.carteiraId,
            isHonorario: isHonorariosTab,
            idDevedorCarteira: idDevedorCarteira || null,
        };

        if (!recordId) {
            if (values.id) {
                payload.id = values.id;
                const updated = pendingContratos.map(c => c.id === values.id ? payload : c);
                setPendingContratos(updated);
            } else {
                payload.id = `temp_${Date.now()}`;
                setPendingContratos([...pendingContratos, payload]);
            }
            showSnackbar("Contrato salvo provisoriamente!", true);
            handleCloseDialog();
            setSubmitting(false);
            return;
        }

        postNoResponse("/contratos/save", payload)
            .then(() => {
                showSnackbar("Contrato salvo com sucesso!", true);
                fetchContratos();
                handleCloseDialog();
            })
            .catch(() => showSnackbar("Erro ao salvar contrato", false))
            .finally(() => setSubmitting(false));
    };

    const handleReativarContratoDireto = (contrato) => {
        setConfirmAction({
            open: true,
            title: "Reativar Contrato",
            message: `Deseja realmente reativar o contrato ${contrato.titulo}?`,
            onConfirm: () => {
                postNoResponse(`/contratos/reativar/${contrato.id}`, {})
                    .then(() => {
                        showSnackbar("Contrato reativado com sucesso!", true);
                        if (onDataUpdated) onDataUpdated();
                        fetchContratos();
                    })
                    .catch(err => {
                        showSnackbar("Erro ao reativar contrato", false);
                    });
            }
        });
    };

    const handleReativarLote = () => {
        const reativarIds = selectedContratos.filter(id => {
            const c = contratos.find(x => x.id === id);
            return c && c.situacao === 4;
        });
        if (reativarIds.length === 0) {
            showSnackbar("Nenhum contrato devolvido selecionado para reativar.", false);
            return;
        }
        setConfirmAction({
            open: true,
            title: "Reativar Selecionados",
            message: `Deseja reativar os ${reativarIds.length} contratos devolvidos selecionados?`,
            onConfirm: () => {
                postNoResponse(`/contratos/reativar-lote`, reativarIds)
                    .then(() => {
                        showSnackbar("Contratos reativados com sucesso!", true);
                        fetchContratos();
                        setSelectedContratos([]);
                    })
                    .catch(err => {
                        showSnackbar("Erro ao reativar contratos", false);
                    });
            }
        });
    };

    const handleDeleteClick = (contrato) => {
        setContratoToDelete(contrato);
        setDeleteDialogOpen(true);
    };

    const confirmDelete = () => {
        if (!contratoToDelete) return;

        if (!recordId || contratoToDelete.id.toString().startsWith("temp_")) {
            const updatedPending = pendingContratos.filter(c => c.id !== contratoToDelete.id);
            setPendingContratos(updatedPending);
            setContratos(updatedPending);
            showSnackbar("Contrato removido com sucesso!", true);
            setDeleteDialogOpen(false);
            setContratoToDelete(null);
            return;
        }

        postNoResponse("/contratos/delete", { id: contratoToDelete.id })
            .then(() => {
                showSnackbar("Contrato excluído com sucesso!", true);
                if (onDataUpdated) onDataUpdated();
                fetchContratos();
            })
            .catch(() => {
                showSnackbar("Erro ao excluir contrato. Pode haver acordos vinculados.", false);
            })
            .finally(() => {
                setDeleteDialogOpen(false);
                setContratoToDelete(null);
            });
    };

    const handleDevolverDireto = (contrato) => {
        setConfirmAction({
            open: true,
            title: "Devolver Contrato",
            message: `Deseja realmente devolver o contrato/título ${contrato.titulo}?`,
            onConfirm: async () => {
                try {
                    await postNoResponse(`/contratos/devolver/${contrato.id}`, {});
                    showSnackbar("Contrato devolvido com sucesso!", true);
                    if (onDataUpdated) onDataUpdated();
                    fetchContratos();
                } catch (e) {
                    showSnackbar("Erro ao devolver contrato", false);
                }
            }
        });
    };

    const handleOpenSolicitarDevolucao = (contrato) => {
        setContratoParaDevolver(contrato);
        setDevolverObs("");
        setDevolverFile(null);
        setOpenDevolverModal(true);
    };

    const getSituacaoLabel = (sit) => {
        switch (sit) {
            case 1: return "Aberto";
            case 2: return "Baixado Parcial";
            case 3: return "Liquidado";
            case 4: return "Devolvida";
            default: return "Aberto";
        }
    };

    const handleSimularCalculoDevedor = () => {
        if (isFichaDevolvida) {
            alert("Não é possível simular acordos para fichas Devolvidas.");
            return;
        }
        if (contratos.length === 0) {
            showSnackbar("Não há contratos para simular.", false);
            return;
        }

        setSimulacaoLoading(true);
        let query = `dataBase=${dataBaseSimulacao}`;
        if (selectedContratos.length > 0) {
            query += `&contratosIds=${selectedContratos.join(',')}`;
        } else {
            const allIds = contratos.map(c => c.id).join(',');
            query += `&contratosIds=${allIds}`;
        }

        get(`/campanha/simular-calculo-devedor/${recordId}?${query}`)
            .then(res => {
                setSimulacaoData(res);
                setSimulacaoOpen(true);
                setSimulacaoMinimizada(false);
            })
            .catch(err => {
                showSnackbar(err.message || "Erro ao simular cálculo ou nenhuma campanha ativa.", false);
            })
            .finally(() => setSimulacaoLoading(false));
    };

    const proceedOpenAcordoModal = (opcao) => {
        setAcordoOpcaoSelecionada(opcao);
        setAcordoQtdParcelas(opcao.parcelaMinima || 1);
        setAcordoPrimeiroVencimento(dataBaseSimulacao);
        setAcordoPeriodicidade(30);
        setAcordoValorEntrada("");
        setAcordoQtdEntrada(1);
        setAcordoVencimentoEntrada(moment(dataBaseSimulacao).format("YYYY-MM-DD"));
        setAcordoEntradasDetalhadas([]);
        setAcordoMleList([]);
        setAcordoComEntrada(false);
        setAcordoIsExcecao(false);
        if (opcao.formaPagamentoDescricao && opcao.formaPagamentoDescricao !== "Todas") {
            setAcordoFormaPagamento(opcao.formaPagamentoDescricao);
        } else {
            setAcordoFormaPagamento("Boleto");
        }
        setAcordoValorManual("");
        setAcordoParcelasGeradas([]);
        setCronogramaCalculado(false);
        setAcordoModalOpen(true);
        setAcordoMinimizado(false);
    };

    const handleOpenAcordoModal = (opcao) => {
        if (isFichaDevolvida) {
            alert("Não é possível simular acordos para fichas Devolvidas.");
            return;
        }
        const checkContratos = selectedContratos.length > 0 ? selectedContratos : contratos.map(c => c.id);
        const hasActive = acordos.some(a =>
            a.situacao === 1 && a.contratos.some(c => checkContratos.includes(c.idContrato))
        );
        if (hasActive) {
            setPendingOpcao(opcao);
            setConfirmCancelOpen(true);
            return;
        }
        proceedOpenAcordoModal(opcao);
    };

    const proceedOpenAcordoManual = () => {
        const regra1x = (simulacaoData?.opcoesParcelamento || []).find(r => 1 >= r.parcelaMinima && 1 <= r.parcelaMaxima);
        const valorInicial = regra1x ? regra1x.totalComDesconto : simulacaoData.totalAtualizado;

        setAcordoOpcaoSelecionada({
            isManual: true,
            totalComDesconto: valorInicial,
            parcelaMinima: 1,
            parcelaMaxima: 999
        });
        setAcordoQtdParcelas(1);
        setAcordoPrimeiroVencimento(dataBaseSimulacao);
        setAcordoPeriodicidade(30);
        setAcordoValorEntrada("");
        setAcordoQtdEntrada(1);
        setAcordoVencimentoEntrada(moment().format("YYYY-MM-DD"));
        setAcordoEntradasDetalhadas([]);
        setAcordoMleList([]);
        setAcordoParcelasGeradas([]);
        setCronogramaCalculado(false);
        setAcordoComEntrada(false);
        setAcordoIsExcecao(false);
        setAcordoFormaPagamento("Boleto");
        setAcordoValorManual(formatCurrencyInput(valorInicial));
        setAcordoModalOpen(true);
        setAcordoMinimizado(false);
    };

    const handleOpenAcordoManual = () => {
        if (isFichaDevolvida) {
            alert("Não é possível simular acordos para fichas Devolvidas.");
            return;
        }
        const checkContratos = selectedContratos.length > 0 ? selectedContratos : contratos.map(c => c.id);
        const hasActive = acordos.some(a =>
            a.situacao === 1 && a.contratos.some(c => checkContratos.includes(c.idContrato))
        );
        if (hasActive) {
            setPendingOpcao({ isManual: true });
            setConfirmCancelOpen(true);
            return;
        }
        proceedOpenAcordoManual();
    };

    // Cálculos em tempo real da regra da campanha correspondente à forma de pagamento e quantidade de parcelas
    const regrasFormaPagamento = (simulacaoData?.opcoesParcelamento || []).filter(r => 
        !r.formaPagamentoDescricao || r.formaPagamentoDescricao === "Todas" || r.formaPagamentoDescricao === acordoFormaPagamento
    );
    const maxParcelasCampanhaForma = regrasFormaPagamento.length > 0 
        ? Math.max(...regrasFormaPagamento.map(r => Number(r.parcelaMaxima) || 1))
        : 0;

    const totalParcelasConfiguradas = Math.max(1, Number(acordoQtdParcelas || 1)) + (acordoComEntrada && formatUncurrency(acordoValorEntrada) > 0 ? (Number(acordoQtdEntrada) || 1) : 0);
    const isAvistaAcordo = Number(acordoQtdParcelas || 1) <= 1 && !acordoComEntrada;
    const regraCampanhaAtual = regrasFormaPagamento.find(r => 
        totalParcelasConfiguradas >= r.parcelaMinima && 
        totalParcelasConfiguradas <= r.parcelaMaxima
    );
    const valorMinimoCampanha = regraCampanhaAtual ? regraCampanhaAtual.totalComDesconto : (simulacaoData?.totalAtualizado || 0);
    const valorIntegralCampanha = simulacaoData?.totalAtualizado || 0;
    const valorDigitadoAcordo = formatUncurrency(acordoValorManual) || 0;

    const isValorAbaixoCampanha = Boolean(acordoOpcaoSelecionada?.isManual && !acordoIsExcecao && regraCampanhaAtual && valorDigitadoAcordo < (valorMinimoCampanha - 0.05));
    const isParcelasForaCampanha = Boolean(!acordoIsExcecao && !regraCampanhaAtual && (simulacaoData?.opcoesParcelamento || []).length > 0);
    const isBloqueadoPorRegra = isValorAbaixoCampanha || isParcelasForaCampanha;

    const handleCalcularCronograma = () => {
        if (!acordoIsExcecao) {
            if (isParcelasForaCampanha) {
                showSnackbar(`A campanha não prevê parcelamento em ${totalParcelasConfiguradas}x para ${acordoFormaPagamento}${maxParcelasCampanhaForma > 0 ? ` (máximo permitido: ${maxParcelasCampanhaForma}x)` : ""}. Ative 'Liberar como Exceção' ou altere a forma de pagamento para prosseguir.`, false);
                return;
            }
            if (isValorAbaixoCampanha) {
                showSnackbar(`Valor mínimo permitido pela campanha para ${totalParcelasConfiguradas}x é ${toCurrency(valorMinimoCampanha)}. Ative 'Liberar como Exceção' para prosseguir com valor inferior.`, false);
                return;
            }
        }

        let total = acordoOpcaoSelecionada?.isManual ? (formatUncurrency(acordoValorManual) || 0) : (acordoOpcaoSelecionada?.totalComDesconto || 0);

        const qtdParcelasNum = Math.max(1, Number(acordoQtdParcelas || 1));

        // Buscar a opção de parcelamento configurada na campanha correspondente à quantidade de parcelas informada
        const opcaoCorrespondente = regraCampanhaAtual || (simulacaoData?.opcoesParcelamento || []).find(op =>
            qtdParcelasNum >= op.parcelaMinima && qtdParcelasNum <= op.parcelaMaxima
        );

        const pctEntradaConfig = opcaoCorrespondente ? Number(opcaoCorrespondente.percentualMinimoEntrada || opcaoCorrespondente.percentualEntrada || 0) : 0;

        let parcelas = [];
        let numParcela = 0;

        if (acordoComEntrada) {
            // CASO 1: Usuário ativou explicitamente o switch "Possui Pagamento de Entrada?"
            let entrada = formatUncurrency(acordoValorEntrada) || 0;
            if (entrada === 0 && pctEntradaConfig > 0 && total > 0) {
                entrada = Number((total * (pctEntradaConfig / 100)).toFixed(2));
                setAcordoValorEntrada(formatCurrencyInput(entrada));
            }

            let saldo = total - entrada;
            let baseVencimento = moment(acordoPrimeiroVencimento || dataBaseSimulacao);

            if (acordoEntradasDetalhadas.length > 0) {
                for (let i = 0; i < acordoEntradasDetalhadas.length; i++) {
                    const ent = acordoEntradasDetalhadas[i];
                    parcelas.push({
                        numeroParcela: ++numParcela,
                        isEntrada: true,
                        isMle: acordoMleList[i] || false,
                        valorParcela: formatUncurrency(ent.valor) || 0,
                        vencimento: ent.vencimento
                    });
                }
                let lastEntrada = moment(acordoEntradasDetalhadas[acordoEntradasDetalhadas.length - 1].vencimento);
                baseVencimento = lastEntrada.add(Number(acordoPeriodicidade), 'days');
                setAcordoPrimeiroVencimento(baseVencimento.format("YYYY-MM-DD"));
            } else if (entrada > 0) {
                let valEntrada = entrada / (acordoQtdEntrada || 1);
                let curVencimento = moment(acordoVencimentoEntrada || dataBaseSimulacao);
                for (let i = 0; i < (acordoQtdEntrada || 1); i++) {
                    parcelas.push({
                        numeroParcela: ++numParcela,
                        isEntrada: true,
                        isMle: acordoMleList[i] || false,
                        valorParcela: valEntrada,
                        vencimento: curVencimento.format("YYYY-MM-DD")
                    });
                    if (i < (acordoQtdEntrada || 1) - 1) {
                        curVencimento.add(Number(acordoPeriodicidade), 'days');
                    }
                }
                baseVencimento = moment(curVencimento).add(Number(acordoPeriodicidade), 'days');
                setAcordoPrimeiroVencimento(baseVencimento.format("YYYY-MM-DD"));
            }

            if (qtdParcelasNum > 0) {
                let valParcela = saldo / qtdParcelasNum;
                let curVencimento = moment(baseVencimento);
                for (let i = 0; i < qtdParcelasNum; i++) {
                    parcelas.push({
                        numeroParcela: ++numParcela,
                        isEntrada: false,
                        valorParcela: valParcela,
                        vencimento: curVencimento.format("YYYY-MM-DD")
                    });
                    curVencimento.add(Number(acordoPeriodicidade), 'days');
                }
            }
        } else {
            // CASO 2: Entrada NÃO ativada como linha avulsa. Respeita exatamente a quantidade de parcelas informada (ex: 12 parcelas -> gera exatamente 12 linhas)
            let curVencimento = moment(acordoPrimeiroVencimento || dataBaseSimulacao);

            if (pctEntradaConfig > 0 && total > 0 && qtdParcelasNum > 1) {
                let valP1 = Number((total * (pctEntradaConfig / 100)).toFixed(2));
                let saldoRestante = total - valP1;
                let qtdDemais = qtdParcelasNum - 1; // Ex: se total parcelas é 12, P1 usa o % de entrada e as 11 restantes dividem o saldo!
                let valDemais = Number((saldoRestante / qtdDemais).toFixed(2));

                // Parcela 1 (com a % de entrada)
                parcelas.push({
                    numeroParcela: ++numParcela,
                    isEntrada: false,
                    valorParcela: valP1,
                    vencimento: curVencimento.format("YYYY-MM-DD")
                });
                curVencimento.add(Number(acordoPeriodicidade), 'days');

                // Parcela 2 até N
                for (let i = 0; i < qtdDemais; i++) {
                    parcelas.push({
                        numeroParcela: ++numParcela,
                        isEntrada: false,
                        valorParcela: valDemais,
                        vencimento: curVencimento.format("YYYY-MM-DD")
                    });
                    curVencimento.add(Number(acordoPeriodicidade), 'days');
                }
            } else {
                let valParcela = total / qtdParcelasNum;
                for (let i = 0; i < qtdParcelasNum; i++) {
                    parcelas.push({
                        numeroParcela: ++numParcela,
                        isEntrada: false,
                        valorParcela: valParcela,
                        vencimento: curVencimento.format("YYYY-MM-DD")
                    });
                    curVencimento.add(Number(acordoPeriodicidade), 'days');
                }
            }
        }

        setAcordoParcelasGeradas(parcelas);
        setCronogramaCalculado(true);
    };

    const handleChangeParcela = (idx, field, value) => {
        let novas = [...acordoParcelasGeradas];
        novas[idx][field] = value;

        if (field === 'valorParcela' && idx < novas.length - 1) {
            const totalBase = acordoOpcaoSelecionada?.isManual ? (formatUncurrency(acordoValorManual) || 0) : (acordoOpcaoSelecionada?.totalComDesconto || 0);

            let sumToIdx = 0;
            for (let i = 0; i <= idx; i++) {
                let v = formatUncurrency(novas[i].valorParcela);
                if (v === null || isNaN(v)) v = Number(novas[i].valorParcela);
                if (isNaN(v)) v = 0;
                sumToIdx += v;
            }

            let restante = totalBase - sumToIdx;
            if (restante < 0) restante = 0;

            let parcelsRemaining = novas.length - 1 - idx;
            let valPerRemaining = restante / parcelsRemaining;

            for (let i = idx + 1; i < novas.length; i++) {
                novas[i].valorParcela = typeof formatCurrencyInput === 'function' ? formatCurrencyInput(valPerRemaining.toFixed(2)) : valPerRemaining;
            }
        }

        setAcordoParcelasGeradas(novas);
    };

    const handleGerarAcordo = () => {
        const isAvista = isAvistaAcordo;
        const totalBase = acordoOpcaoSelecionada.isManual ? (formatUncurrency(acordoValorManual) || 0) : acordoOpcaoSelecionada.totalComDesconto;

        if (!isAvista && (!cronogramaCalculado || acordoParcelasGeradas.length === 0)) {
            showSnackbar("Calcule as parcelas antes de confirmar e gerar o acordo.", false);
            return;
        }

        // Verifica regra de campanha
        if (!acordoIsExcecao) {
            if (isParcelasForaCampanha) {
                showSnackbar(`Parcelamento em ${totalParcelasConfiguradas}x não permitido para ${acordoFormaPagamento} pela campanha${maxParcelasCampanhaForma > 0 ? ` (máximo permitido: ${maxParcelasCampanhaForma}x)` : ""}. Ative 'Liberar como Exceção' ou altere a forma de pagamento para prosseguir.`, false);
                return;
            }
            if (isValorAbaixoCampanha) {
                showSnackbar(`Valor mínimo permitido para ${totalParcelasConfiguradas}x pela campanha é ${toCurrency(valorMinimoCampanha)}. Marque 'Liberar como Exceção' se deseja prosseguir com valor inferior.`, false);
                return;
            }
        }

        let isSingleParcel = (Number(acordoQtdParcelas) === 1 && !acordoComEntrada);

        let finalParcelas = [];
        if (isAvista || (isSingleParcel && acordoParcelasGeradas.length === 0)) {
            finalParcelas = [{
                numeroParcela: 1,
                valorParcela: totalBase,
                vencimento: acordoPrimeiroVencimento,
                cbEntrada: false,
                cbMle: false
            }];
        } else {
            if (acordoParcelasGeradas.length === 0) {
                showSnackbar("Gere o cronograma primeiro", false);
                return;
            }

            let sum = 0;
            for (let p of acordoParcelasGeradas) {
                let v = formatUncurrency(p.valorParcela);
                if (v === null) v = Number(p.valorParcela);
                sum += v;
            }

            if (sum < totalBase - 0.10) {
                showSnackbar("A soma das parcelas não pode ser menor que o Total a Pagar do acordo.", false);
                return;
            }

            finalParcelas = acordoParcelasGeradas.map((p, i) => ({
                numeroParcela: i + 1,
                valorParcela: formatUncurrency(p.valorParcela) !== null ? formatUncurrency(p.valorParcela) : p.valorParcela,
                vencimento: p.vencimento.length === 10 ? p.vencimento + "T12:00:00" : p.vencimento,
                cbEntrada: p.isEntrada || false,
                cbMle: p.isMle || false
            }));
        }

        setAcordoLoading(true);
        const checkContratos = selectedContratos.length > 0 ? selectedContratos : contratos.map(c => c.id);
        const hasActive = acordos.some(a =>
            a.situacao === 1 && a.contratos.some(c => checkContratos.includes(c.idContrato))
        );

        const payload = {
            idDevedor: recordId,
            cancelarAcordoAtual: hasActive,
            idCampanha: simulacaoData?.campanhaId || null,
            valorOriginalTotal: simulacaoData.valorOriginal,
            valorAcordoTotal: totalBase,
            descontoAplicado: simulacaoData.totalAtualizado - totalBase,
            multaAplicada: simulacaoData.valorMulta,
            jurosAplicados: simulacaoData.valorJuros,
            correcaoAplicada: simulacaoData.valorCorrecao,
            honorariosAplicados: simulacaoData.valorHonorarios,
            formaPagamento: acordoFormaPagamento,
            qtdParcelas: finalParcelas.length,
            primeiroVencimento: finalParcelas[0].vencimento,
            parcelas: finalParcelas,
            contratos: contratos.filter(c => (c.situacao === 1 || c.situacao === 2) && (selectedContratos.length === 0 || selectedContratos.includes(c.id))).map(c => ({
                idContrato: c.id,
                titulo: c.titulo,
                valorNegociado: c.saldo // Simplificado
            })),
            // Força false se estiver na aba de Honorários para evitar gerar débitos duplos
            gerarDividaHonorarios: isHonorariosTab ? false : gerarHO,
            percentualHonorarios: (isHonorariosTab || !gerarHO) ? null : parseFloat(hoPercentual),
            tipoHonorario: (isHonorariosTab || !gerarHO) ? null : hoTipo
        };

        const performSave = (extraPayload = {}) => {
            const finalPayload = { ...payload, ...extraPayload };
            post("/acordo/save", finalPayload)
                .then((response) => {
                    showSnackbar("Acordo gerado com sucesso! Vá para a aba Acordos para visualizar.", true);
                    setAcordoModalOpen(false);
                    setAcordoMinimizado(false);
                    setSimulacaoOpen(false);
                    setSimulacaoMinimizada(false);
                    setGerarHO(false); // Limpa para evitar loops em negociações sequenciais
                    fetchContratos(); // Atualiza a lista
                    if (onDataUpdated) onDataUpdated();

                    if (response && response.idHonorarioGerado) {
                        setConfirmAction({
                            open: true,
                            title: "Honorários Gerados",
                            message: "A dívida de Honorários foi criada com sucesso! Você foi redirecionado para a aba de Honorários. Por favor, acesse a nova ficha gerada para formalizar o acordo.",
                            onConfirm: () => {
                                if (changeTab) changeTab(6); // Switch to Honorarios Tab
                            },
                            confirmText: "Ir para Honorários",
                            cancelText: "Fechar"
                        });
                    } else if (acordoFormaPagamento === 'Boleto' && response && response.idPrimeiraParcela) {
                        const canEmitirBoleto = !contratos.some(c => checkContratos.includes(c.id) && c.emiteBoleto === false);
                        if (canEmitirBoleto) {
                            setConfirmAction({
                                open: true,
                                title: "Acordo Gerado",
                                message: "Acordo gerado com sucesso! Deseja emitir o boleto da 1ª parcela agora?",
                                onConfirm: () => {
                                    setLoading(true);
                                    getFile(`/acordo/parcela/boleto/${response.idPrimeiraParcela}`, "boleto.pdf")
                                        .catch(err => showSnackbar(err.message || "Erro ao emitir boleto", false))
                                        .finally(() => setLoading(false));
                                }
                            });
                        }
                    }
                })
                .catch((err) => {
                    showSnackbar(err.message || "Erro ao gerar acordo", false);
                })
                .finally(() => setAcordoLoading(false));
        };

        const isHonorarioSimulation = selectedContratos.length > 0 && selectedContratos.some(id => !contratos.find(c => c.id === id));

        if (contratos.length > 0 && !isHonorariosTab && !isHonorarioSimulation) {
            get(`/acordo/honorarios-state-by-contrato/${contratos[0].id}`)
                .then(state => {
                    if (state && state.hasHonorariosFicha) {
                        if (state.hasActiveAcordo) {
                            setConfirmAction({
                                open: true,
                                title: "Acordo de Honorários Vigente",
                                message: "Este cliente já possui um acordo de honorários em andamento." + (state.hasPaymentsInAcordo ? " ALERTA: Existem pagamentos efetivados neste acordo!" : "") + " Deseja cancelar o acordo de honorários vigente também?",
                                onConfirm: () => performSave({ cancelarAcordoHonorarios: true }),
                                onCancel: () => performSave({ cancelarAcordoHonorarios: false }),
                                confirmText: "Sim, Cancelar",
                                cancelText: "Não Cancelar",
                                confirmColor: "error"
                            });
                        } else {
                            setConfirmAction({
                                open: true,
                                title: "Ficha de Honorários Órfã",
                                message: "Identificamos uma Ficha de Honorários pendente neste contrato, mas sem acordo formalizado. Deseja excluir esta ficha permanentemente?",
                                onConfirm: () => performSave({ excluirFichaHonorarios: true }),
                                onCancel: () => performSave({ excluirFichaHonorarios: false }),
                                confirmText: "Sim, Excluir",
                                cancelText: "Manter Ficha",
                                confirmColor: "error"
                            });
                        }
                    } else {
                        performSave();
                    }
                })
                .catch(err => {
                    performSave();
                });
        } else {
            performSave();
        }
    };

    const [migracaoModalOpen, setMigracaoModalOpen] = useState(false);
    const [tipoSolicitacao, setTipoSolicitacao] = useState("MIGRACAO"); // "MIGRACAO" ou "DEVOLUCAO"
    const [carteirasOptions, setCarteirasOptions] = useState([]);
    const [carteirasMigracaoOptions, setCarteirasMigracaoOptions] = useState([]);
    const [usuariosOptions, setUsuariosOptions] = useState([]);
    const [statusFichaOptions, setStatusFichaOptions] = useState([]);
    const [selectedCarteiraMigracao, setSelectedCarteiraMigracao] = useState("");
    const [selectedUsuarioMigracao, setSelectedUsuarioMigracao] = useState("");
    const [selectedStatusMigracao, setSelectedStatusMigracao] = useState("");
    const [observacaoMigracao, setObservacaoMigracao] = useState("");
    const [migracaoFile, setMigracaoFile] = useState(null);

    useEffect(() => {
        get("/carteira/list-all").then(res => {
            if (res && res.list) {
                setCarteirasOptions(res.list);
            }
        }).catch(() => console.error("Erro ao carregar carteiras"));

        get("/carteira/destinos-migracao").then(res => {
            const list = res?.list || res?.data || (Array.isArray(res) ? res : []);
            setCarteirasMigracaoOptions(list.filter(c => {
                const nome = (c.nome || c.ccNome || "").toLowerCase();
                return !nome.includes("processo");
            }));
        }).catch(() => console.error("Erro ao carregar carteiras de migracao"));
    }, []);

    useEffect(() => {
        if (!selectedCarteiraMigracao) {
            setUsuariosOptions([]);
            return;
        }
        get(`/users/list-all-operators?carteiraId=${selectedCarteiraMigracao}`).then(res => {
            if (res && res.list) {
                setUsuariosOptions(res.list);
            } else {
                setUsuariosOptions([]);
            }
        }).catch(() => setUsuariosOptions([]));
    }, [selectedCarteiraMigracao]);

    const handleOpenMigracaoModal = () => {
        let targets = selectedContratos;
        if (targets.length === 0) {
            if (contratosFiltrados.length === 1) {
                targets = [contratosFiltrados[0].id];
                setSelectedContratos(targets);
            } else if (contratosFiltrados.length > 1) {
                targets = contratosFiltrados.map(c => c.id);
                setSelectedContratos(targets);
            } else {
                showSnackbar("Não existem contratos disponíveis nesta ficha.", false);
                return;
            }
        }
        setTipoSolicitacao("MIGRACAO");
        setLoading(true);
        Promise.all([
            get("/carteira/destinos-migracao").catch(() => get("/carteira/list-all").catch(() => null)),
            get("/status-ficha/list-all").catch(() => null)
        ]).then(([cartRes, statusRes]) => {
            const carteirasRaw = cartRes?.list || cartRes?.data || (Array.isArray(cartRes) ? cartRes : []);
            const filteredCarteiras = carteirasRaw.filter(c => {
                const nome = (c.nome || c.ccNome || "").toLowerCase();
                return !nome.includes("processo");
            });
            const statusList = statusRes?.list || statusRes?.data || (Array.isArray(statusRes) ? statusRes : []);
            setCarteirasMigracaoOptions(filteredCarteiras);
            setStatusFichaOptions(statusList);
            setSelectedCarteiraMigracao(filteredCarteiras.length === 1 ? (filteredCarteiras[0].id || filteredCarteiras[0].cvId) : "");
            setSelectedUsuarioMigracao("");
            setSelectedStatusMigracao("");
            setObservacaoMigracao("");
            setMigracaoFile(null);
            setMigracaoModalOpen(true);
        }).finally(() => setLoading(false));
    };

    const handleConfirmMigracao = async () => {
        const targets = selectedContratos.length > 0 ? selectedContratos : contratosFiltrados.map(c => c.id);

        if (tipoSolicitacao === "MIGRACAO") {
            if (!selectedCarteiraMigracao) {
                showSnackbar("Selecione uma carteira de destino.", false);
                return;
            }
            setLoading(true);

            let arquivoBase64 = null;
            let nomeArquivo = null;
            if (migracaoFile) {
                nomeArquivo = migracaoFile.name;
                arquivoBase64 = await new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = () => resolve(null);
                    reader.readAsDataURL(migracaoFile);
                });
            }

            postNoResponse("/devedor/testar-migracao", {
                id: recordId,
                contratosIds: targets,
                carteiraId: selectedCarteiraMigracao,
                usuarioId: isDirectMigrateUser ? selectedUsuarioMigracao : null,
                statusFichaId: isDirectMigrateUser ? selectedStatusMigracao : null,
                observacao: observacaoMigracao,
                arquivoBase64,
                nomeArquivo
            })
                .then(() => {
                    const msg = isDirectMigrateUser
                        ? "Migração concluída com sucesso! Atualize a página."
                        : "Solicitação de migração de carteira enviada com sucesso para a Fila do Suporte!";
                    showSnackbar(msg, true);
                    setMigracaoModalOpen(false);
                    setSelectedContratos([]);
                    fetchContratos();
                    if (onDataUpdated) onDataUpdated();
                })
                .catch((err) => {
                    showSnackbar(err.message || "Erro na migração", false);
                })
                .finally(() => setLoading(false));
        } else {
            // DEVOLUCAO
            if (!observacaoMigracao.trim()) {
                showSnackbar("Por favor, preencha o motivo/observação da devolução.", false);
                return;
            }
            setLoading(true);
            const isParcial = selectedContratos.length > 0 && selectedContratos.length < contratosFiltrados.length;

            try {
                if (isDirectMigrateUser) {
                    if (isParcial) {
                        for (const cId of targets) {
                            await postNoResponse(`/contratos/devolver/${cId}`, {});
                        }
                    } else {
                        await postNoResponse(`/devedor/devolver/${recordId}`, {});
                    }
                    showSnackbar("Devolução realizada com sucesso!", true);
                } else {
                    if (isParcial) {
                        for (const cId of targets) {
                            await postNoResponse(`/contratos/solicitar-devolucao/${cId}`, { observacao: observacaoMigracao });
                            if (migracaoFile) {
                                const formData = new FormData();
                                formData.append("file", migracaoFile);
                                await postUploadNoResponse(`/contratos/solicitar-devolucao/${cId}/anexo`, formData).catch(() => {});
                            }
                        }
                    } else {
                        await postNoResponse(`/devedor/solicitar-devolucao/${recordId}`, { observacao: observacaoMigracao });
                        if (migracaoFile) {
                            const formData = new FormData();
                            formData.append("file", migracaoFile);
                            await postUploadNoResponse(`/devedor/solicitar-devolucao/${recordId}/anexo`, formData).catch(() => {});
                        }
                    }
                    showSnackbar("Solicitação de devolução enviada com sucesso para a Fila do Suporte!", true);
                }
                setMigracaoModalOpen(false);
                setSelectedContratos([]);
                fetchContratos();
                if (onDataUpdated) onDataUpdated();
            } catch (err) {
                showSnackbar(err.message || "Erro ao processar devolução", false);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleOpenReagruparModal = () => {
        const currentFichaId = selectedFicha?.rawId || selectedFicha?.id || idDevedorCarteiraRaw || idDevedorCarteira;

        const loadFichas = (fichasList) => {
            const outras = (fichasList || []).filter(f => {
                const fId = f.rawId || f.id;
                return String(fId) !== String(currentFichaId);
            });
            setFichasDisponiveis(outras);
            if (outras.length > 0) {
                setReagruparDestinoId(outras[0].rawId || outras[0].id);
            } else {
                setReagruparDestinoId("");
            }
        };

        if (preloadedDevedor?.fichas && preloadedDevedor.fichas.length > 0) {
            loadFichas(preloadedDevedor.fichas);
        } else if (recordId) {
            get(`/devedor/by-id/${recordId}`).then(res => {
                if (res?.fichas) {
                    loadFichas(res.fichas);
                }
            }).catch(() => {});
        }

        if (selectedContratos.length > 0 && selectedContratos.length < contratosFiltrados.length) {
            setReagruparMoverTodos(false);
        } else {
            setReagruparMoverTodos(true);
        }
        setReagruparMotivo("");
        setReagruparModalOpen(true);
    };

    const handleConfirmReagrupar = () => {
        const currentFichaId = selectedFicha?.rawId || selectedFicha?.id || idDevedorCarteiraRaw || idDevedorCarteira;
        if (!currentFichaId) {
            showSnackbar("Não foi possível identificar a ficha de origem atual.", false);
            return;
        }
        if (!reagruparDestinoId) {
            showSnackbar("Selecione a ficha de destino para onde os débitos serão transferidos.", false);
            return;
        }
        if (!reagruparMoverTodos && selectedContratos.length === 0) {
            showSnackbar("Selecione ao menos um contrato na tabela ou escolha 'Mover todos os débitos'.", false);
            return;
        }

        setIsSubmittingReagrupamento(true);
        const payload = {
            idOrigem: currentFichaId,
            idDestino: reagruparDestinoId,
            idsContratos: reagruparMoverTodos ? [] : selectedContratos,
            moverTodos: reagruparMoverTodos,
            motivo: reagruparMotivo
        };

        post("/devedor/carteira/reagrupar-debitos", payload)
            .then(res => {
                showSnackbar(res?.message || "Débitos reagrupados com sucesso!", true);
                setReagruparModalOpen(false);
                setSelectedContratos([]);
                window.dispatchEvent(new Event("devedorStatusUpdated"));
                if (onDataUpdated) onDataUpdated();
                fetchContratos();
            })
            .catch(err => {
                const msg = err?.response?.data?.message || err?.message || "Erro ao reagrupar débitos.";
                showSnackbar(msg, false);
            })
            .finally(() => {
                setIsSubmittingReagrupamento(false);
            });
    };

    const isFilhoFicha = isTerceiroFicha || Boolean(preloadedDevedor?.idDevedorPai);
    const contratosBase = isHonorariosTab
        ? contratos.filter(c => c.isHonorario === true)
        : contratos.filter(c => isFilhoFicha || c.isTerceiro === true || c.isHonorario !== true);
    const isFichaQuitada = selectedFicha?.situacao === 7;
    const temContratosAtivos = contratosBase.some(c => c.situacao === 1 || c.situacao === 2);
    const contratosFiltrados = (apenasAtivos && temContratosAtivos && !isFichaQuitada) 
        ? contratosBase.filter(c => c.situacao === 1 || c.situacao === 2) 
        : contratosBase;

    return (
        <MDBox mt={2}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <MDBox display="flex" alignItems="center">
                    {selectedFicha && (
                        <Chip 
                            icon={<Icon fontSize="small">receipt_long</Icon>}
                            label={`[Ficha #${selectedFicha.rawId || selectedFicha.id}] ${selectedFicha.nomeCarteira || "Carteira"}${selectedFicha.situacao === 1 ? " (Devolvida)" : (selectedFicha.situacao === 7 ? " (Quitada)" : "")}`}
                            color={selectedFicha.situacao === 1 ? "error" : (selectedFicha.situacao === 7 ? "secondary" : "info")}
                            variant="outlined"
                            sx={{ 
                                fontWeight: "bold", 
                                fontSize: "11px", 
                                height: "24px", 
                                mr: 1.5,
                                borderColor: selectedFicha.situacao === 7 ? "#ab47bc" : undefined,
                                color: selectedFicha.situacao === 7 ? "#ab47bc" : undefined
                            }}
                        />
                    )}
                    <FormControlLabel
                        control={
                            <Switch
                                checked={apenasAtivos}
                                onChange={(e) => {
                                    setApenasAtivos(e.target.checked);
                                    setPage(0);
                                }}
                                color="info"
                            />
                        }
                        label={<MDTypography variant="button" fontWeight="regular" color="text" sx={{ cursor: "pointer", userSelect: "none", ml: -0.5 }}>Apenas Ativos</MDTypography>}
                        sx={{ margin: 0 }}
                    />
                </MDBox>
                <MDBox display="flex">
                    {recordId && isDirectMigrateUser && (
                        <MDButton 
                            variant="outlined" 
                            color="info" 
                            size="small" 
                            onClick={handleOpenReagruparModal} 
                            sx={{ mr: 1 }}
                        >
                            <Icon sx={{ mr: 0.5 }}>merge</Icon> Reagrupar Débitos
                        </MDButton>
                    )}
                    {recordId && (
                        <MDButton variant="outlined" color="warning" size="small" onClick={handleOpenMigracaoModal} sx={{ mr: 1 }}>
                            <Icon sx={{ mr: 1 }}>swap_horiz</Icon> {isDirectMigrateUser ? "Migrar / Devolver" : "Solicitar Migração / Devolução"}
                        </MDButton>
                    )}
                    {!isViewOnly && recordId && isAdminOrSuporte && selectedContratos.some(id => contratos.find(c => c.id === id)?.situacao === 4) && (
                        <MDButton variant="contained" color="success" size="small" onClick={handleReativarLote} sx={{ mr: 1 }}>
                            <Icon sx={{ mr: 1 }}>restore</Icon> Reativar Selecionados
                        </MDButton>
                    )}
                    {!isViewOnly && (
                        <MDButton variant="contained" color="info" size="small" onClick={() => handleOpenDialog()}>
                            <Icon sx={{ mr: 1 }}>add</Icon> Novo Contrato
                        </MDButton>
                    )}
                </MDBox>
            </MDBox>

            <TableContainer sx={{ boxShadow: "none" }}>
                <Table>
                    <MDBox component="thead">
                        <TableRow>
                            <TableCell padding="checkbox" align="center" sx={{ borderBottom: "1px solid #f0f2f5" }}>
                                <Checkbox
                                    color="primary"
                                    indeterminate={selectedContratos.length > 0 && selectedContratos.length < contratosFiltrados.length}
                                    checked={contratosFiltrados.length > 0 && selectedContratos.length === contratosFiltrados.length}
                                    onChange={handleSelectAllClick}
                                />
                            </TableCell>
                            <DataTableHeadCell width="auto" sorted={false}>Título</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Carteira</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Descrição</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Parcela</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Vencimento</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Valor</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Saldo</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Situação</DataTableHeadCell>
                            {(!isViewOnly || recordId) && <DataTableHeadCell width="auto" align="center" sorted={false}>Ações</DataTableHeadCell>}
                        </TableRow>
                    </MDBox>
                    <TableBody>
                        {contratosFiltrados.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={(!isViewOnly || recordId) ? 10 : 9} align="center" sx={{ py: 3, borderBottom: "none" }}>
                                    <MDTypography variant="caption" color="text">Nenhum contrato encontrado.</MDTypography>
                                </TableCell>
                            </TableRow>
                        )}
                        {contratosFiltrados.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => {
                            const rowId = item.id || `temp_idx_${index}`;
                            const isSelected = selectedContratos.includes(rowId);
                            return (
                                <TableRow key={rowId} selected={isSelected} hover>
                                    <TableCell padding="checkbox" align="center" sx={{ borderBottom: "1px solid #f0f2f5" }}>
                                        <Checkbox
                                            color="primary"
                                            checked={isSelected}
                                            onChange={(e) => {
                                                setSelectedContratos(prev =>
                                                    prev.includes(rowId) ? prev.filter(i => i !== rowId) : [...prev, rowId]
                                                );
                                            }}
                                        />
                                    </TableCell>
                                    <DataTableBodyCell isProcess={true}>
                                        <MDBox display="flex" alignItems="center">
                                            <MDTypography variant="caption" fontWeight="regular" color="text">{item.titulo}</MDTypography>
                                            {item.numeroProcesso && (
                                                <Chip label={`Processo: ${item.numeroProcesso}`} size="small" color="info" variant="outlined" sx={{ ml: 1, height: 20, fontSize: '0.65rem' }} />
                                            )}
                                        </MDBox>
                                    </DataTableBodyCell>
                                    <DataTableBodyCell isProcess={true}>
                                        {(() => {
                                            const matchingFicha = (preloadedDevedor?.fichas || []).find(f => f.id === item.idDevedorCarteira || String(f.rawId) === String(item.idDevedorCarteira));
                                            const fichaIdText = matchingFicha?.rawId ? `[#${matchingFicha.rawId}] ` : "";
                                            const cartText = item.nomeCarteira || matchingFicha?.nomeCarteira;
                                            return cartText ? (
                                                <MDTypography variant="caption" fontWeight="medium" color="info">
                                                    {fichaIdText}{cartText}
                                                </MDTypography>
                                            ) : (
                                                <MDTypography variant="caption" fontWeight="regular" color="text">-</MDTypography>
                                            );
                                        })()}
                                    </DataTableBodyCell>
                                    <DataTableBodyCell isProcess={true}>
                                        <MDTypography
                                            variant="caption"
                                            fontWeight="regular"
                                            color="text"
                                            title={item.descricao}
                                            sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 200, display: 'block' }}
                                        >
                                            {item.descricao || "-"}
                                        </MDTypography>
                                    </DataTableBodyCell>
                                    <DataTableBodyCell isProcess={true}>
                                        <MDTypography variant="caption" fontWeight="regular" color="text">{item.parcela}</MDTypography>
                                    </DataTableBodyCell>
                                    <DataTableBodyCell isProcess={true}>
                                        <MDTypography variant="caption" fontWeight="regular" color="text">{item.vencimento ? moment.utc(item.vencimento).format("DD/MM/YYYY") : ""}</MDTypography>
                                    </DataTableBodyCell>
                                    <DataTableBodyCell isProcess={true}>
                                        <MDTypography variant="caption" fontWeight="regular" color="text">{toCurrency(item.valorOriginal)}</MDTypography>
                                    </DataTableBodyCell>
                                    <DataTableBodyCell isProcess={true}>
                                        <MDTypography variant="caption" fontWeight="regular" color="text">{toCurrency(item.saldo)}</MDTypography>
                                    </DataTableBodyCell>
                                    <DataTableBodyCell isProcess={true}>
                                        <MDTypography variant="caption" fontWeight="regular" color="text">{getSituacaoLabel(item.situacao)}</MDTypography>
                                    </DataTableBodyCell>
                                    {(!isViewOnly || recordId) && (
                                        <DataTableBodyCell align="center" isProcess={true}>
                                            {!isViewOnly && !isFila && (
                                                <>
                                                    <IconButton color="info" size="small" onClick={() => handleOpenDialog(item)} sx={{ p: 0.5 }}>
                                                        <Icon fontSize="small">edit</Icon>
                                                    </IconButton>
                                                    <IconButton color="error" size="small" onClick={() => handleDeleteClick(item)} sx={{ p: 0.5, ml: 1 }}>
                                                        <Icon fontSize="small">delete</Icon>
                                                    </IconButton>
                                                </>
                                            )}
                                            {recordId && item.situacao !== 4 && (
                                                isAdminOrSuporte ? (
                                                    <IconButton color="error" size="small" onClick={() => handleDevolverDireto(item)} sx={{ p: 0.5, ml: 1 }} title="Devolver Contrato" disabled={isFichaDevolvida}>
                                                        <Icon fontSize="small">assignment_return</Icon>
                                                    </IconButton>
                                                ) : (
                                                    <IconButton color="warning" size="small" onClick={() => handleOpenSolicitarDevolucao(item)} sx={{ p: 0.5, ml: 1 }} title="Solicitar Devolução" disabled={isFichaDevolvida}>
                                                        <Icon fontSize="small">assignment_return</Icon>
                                                    </IconButton>
                                                )
                                            )}
                                            {recordId && item.situacao === 4 && isAdminOrSuporte && (
                                                <IconButton color="success" size="small" onClick={() => handleReativarContratoDireto(item)} sx={{ p: 0.5, ml: 1 }} title="Reativar Contrato">
                                                    <Icon fontSize="small">restore</Icon>
                                                </IconButton>
                                            )}
                                        </DataTableBodyCell>
                                    )}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            {contratosFiltrados.length > 0 && (
                <TablePagination
                    component="div"
                    count={contratosFiltrados.length}
                    page={page}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(parseInt(e.target.value, 10));
                        setPage(0);
                    }}
                    labelRowsPerPage="Itens por pág:"
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    sx={{
                        color: darkMode ? "#fff" : "inherit",
                        ".MuiTablePagination-toolbar": { minHeight: 36, paddingLeft: 1, paddingRight: 1 },
                        ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": { fontSize: "0.75rem", margin: 0, color: darkMode ? "#fff" : "inherit" },
                        ".MuiTablePagination-select": { fontSize: "0.75rem", color: darkMode ? "#fff" : "inherit" },
                        ".MuiTablePagination-selectIcon": { color: darkMode ? "#fff" : "inherit" },
                        ".MuiTablePagination-actions button": { color: darkMode ? "#fff" : "inherit" }
                    }}
                />
            )}

            <MDBox mt={3} p={2} bgcolor="background.default" borderRadius={2} border="1px solid" borderColor="divider">
                <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={4} md={3}>
                        <MDInput
                            type="date"
                            label="Data Base para Simulação"
                            name="dataBaseSimulacao"
                            value={dataBaseSimulacao}
                            onChange={(e) => setDataBaseSimulacao(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <MDButton
                            variant="contained"
                            color="success"
                            size="medium"
                            fullWidth
                            onClick={() => handleSimularCalculoDevedor()}
                            disabled={simulacaoLoading || contratos.length === 0}
                        >
                            <Icon sx={{ mr: 1 }}>calculate</Icon> Simular Ficha Completa
                        </MDButton>
                    </Grid>
                </Grid>
            </MDBox>

            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>{selectedContrato ? "Editar Contrato" : "Novo Contrato"}</DialogTitle>
                <Formik
                    initialValues={{
                        id: selectedContrato?.id || "",
                        titulo: selectedContrato?.titulo || "",
                        descricao: selectedContrato?.descricao || "",
                        parcela: selectedContrato?.parcela || "Única",
                        vencimento: selectedContrato?.vencimento ? moment.utc(selectedContrato.vencimento).format("YYYY-MM-DD") : "",
                        dataInclusao: (selectedContrato?.dataInclusao || selectedContrato?.cdCriacao)
                            ? moment(selectedContrato.dataInclusao || selectedContrato.cdCriacao).format("DD/MM/YYYY HH:mm")
                            : (selectedContrato ? "-" : moment().format("DD/MM/YYYY HH:mm")),
                        valorOriginal: selectedContrato?.valorOriginal ? formatCurrencyInput(selectedContrato.valorOriginal) : "",
                        saldo: selectedContrato?.saldo ? formatCurrencyInput(selectedContrato.saldo) : "",
                        situacao: selectedContrato?.situacao || 1,
                        marcacoesIds: selectedContrato?.marcacoesIds || [],
                        carteiraId: selectedContrato?.idCarteira || (carteirasOptions.length === 1 ? carteirasOptions[0].id : ""),
                    }}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ values, handleChange, setFieldValue, isSubmitting }) => (
                        <Form>
                            <DialogContent dividers>
                                <Grid container spacing={2} alignItems="flex-start">
                                    <Grid item xs={12} sm={2.8}>
                                        <FormField
                                            type="text"
                                            label="Título"
                                            name="titulo"
                                            value={values.titulo}
                                            onChange={handleChange}
                                            placeholder="Ex: Nota Fiscal 123"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <FormField
                                            type="text"
                                            label="Parcela"
                                            name="parcela"
                                            value={values.parcela}
                                            onChange={handleChange}
                                            placeholder="Ex: 01/12"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2.4}>
                                        <FormField
                                            type="date"
                                            label="Vencimento"
                                            name="vencimento"
                                            value={values.vencimento}
                                            onChange={handleChange}
                                            required
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2.4}>
                                        <FormField
                                            type="text"
                                            label="Data de Inclusão"
                                            name="dataInclusao"
                                            value={values.dataInclusao}
                                            InputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2.4}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2, color: darkMode ? "#fff" : "inherit" }}>
                                            Situação
                                        </InputLabel>
                                        <MDInput
                                            select
                                            name="situacao"
                                            value={values.situacao}
                                            onChange={handleChange}
                                            fullWidth
                                            size="small"
                                        >
                                            <MenuItem value={1}>Aberto</MenuItem>
                                            <MenuItem value={2}>Baixado Parcial</MenuItem>
                                            <MenuItem value={3}>Liquidado</MenuItem>
                                            <MenuItem value={4}>Cancelado</MenuItem>
                                        </MDInput>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2, color: darkMode ? "#fff" : "inherit" }}>
                                            Marcação Especial
                                        </InputLabel>
                                        <MDSelect
                                            isMulti={true}
                                            getOptionValue={(option) => option.cvId}
                                            getOptionLabel={(option) => option.ccNome}
                                            name="marcacoesIds"
                                            placeholder="Selecione as marcações..."
                                            value={marcacoes.filter(m => values.marcacoesIds && values.marcacoesIds.includes(m.cvId))}
                                            options={marcacoes}
                                            onChange={(selected) => {
                                                const val = selected ? selected.map(s => s.cvId) : [];
                                                setFieldValue("marcacoesIds", val);
                                            }}
                                            isDisabled={isViewOnly}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2, color: darkMode ? "#fff" : "inherit" }}>
                                            Carteira
                                        </InputLabel>
                                        <MDInput
                                            select
                                            name="carteiraId"
                                            value={values.carteiraId || ""}
                                            onChange={handleChange}
                                            fullWidth
                                            size="small"
                                            disabled={carteirasOptions.length === 1 || isViewOnly}
                                        >
                                            {carteirasOptions.map(c => (
                                                <MenuItem key={c.id} value={c.id}>{c.nome}</MenuItem>
                                            ))}
                                        </MDInput>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormField
                                            type="text"
                                            label="Descrição do Débito"
                                            name="descricao"
                                            value={values.descricao}
                                            onChange={handleChange}
                                            placeholder="Ex: Confissão de dívida assinada..."
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormField
                                            type="text"
                                            label="Valor Original"
                                            name="valorOriginal"
                                            value={values.valorOriginal}
                                            onChange={(e) => {
                                                const formatted = formatCurrencyInput(e.target.value);
                                                setFieldValue("valorOriginal", formatted);
                                                setFieldValue("saldo", formatted);
                                            }}
                                            placeholder="R$ 0,00"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormField
                                            type="text"
                                            label="Saldo"
                                            name="saldo"
                                            value={values.saldo}
                                            onChange={(e) => setFieldValue("saldo", formatCurrencyInput(e.target.value))}
                                            placeholder="R$ 0,00"
                                            required
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <MDButton color="secondary" onClick={handleCloseDialog}>
                                    Cancelar
                                </MDButton>
                                <MDButton color="info" type="submit" disabled={isSubmitting}>
                                    Salvar
                                </MDButton>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            {/* Simulação Dialog */}
            {simulacaoData && (() => {
                const handlePrintSimulacao = () => {
                    const printWindow = window.open('', '_blank', 'width=900,height=700');
                    if (!printWindow) return;

                    const devedorNome = simulacaoData.devedorNome || "";
                    const dataSimulacao = simulacaoData.dataSimulacao ? `Simulação gerada para a data base: ${simulacaoData.dataSimulacao}` : `Atraso: ${simulacaoData.atrasoDias || 0} dias`;

                    let contratosRows = "";
                    if (simulacaoData.contratosCalculadosList && simulacaoData.contratosCalculadosList.length > 0) {
                        contratosRows = simulacaoData.contratosCalculadosList.map(c => `
                            <tr>
                                <td style="padding: 8px 10px; border: 1px solid #ccc;">${c.titulo || ''} ${c.parcela && c.parcela !== "Única" ? `(${c.parcela})` : ''}</td>
                                <td style="padding: 8px 10px; border: 1px solid #ccc; text-align: right;">${c.atrasoDias || 0} dias</td>
                                <td style="padding: 8px 10px; border: 1px solid #ccc; text-align: right;">${toCurrency(c.valorOriginal)}</td>
                                <td style="padding: 8px 10px; border: 1px solid #ccc; text-align: right; color: #ef6c00;">+${toCurrency(c.valorCorrecao || 0)}</td>
                                <td style="padding: 8px 10px; border: 1px solid #ccc; text-align: right; color: #d32f2f;">+${toCurrency(c.valorMulta)}</td>
                                <td style="padding: 8px 10px; border: 1px solid #ccc; text-align: right; color: #d32f2f;">+${toCurrency(c.valorJuros)}</td>
                                <td style="padding: 8px 10px; border: 1px solid #ccc; text-align: right; color: #d32f2f;">+${toCurrency(c.valorHonorarios)}</td>
                                <td style="padding: 8px 10px; border: 1px solid #ccc; text-align: right; font-weight: bold;">${toCurrency(c.totalAtualizado)}</td>
                            </tr>
                        `).join('');
                    }

                    const htmlContent = `
                        <!DOCTYPE html>
                        <html>
                        <head>
                            <meta charset="utf-8" />
                            <title>Cálculo Devedor - ${devedorNome}</title>
                            <style>
                                @page { margin: 15mm; }
                                body {
                                    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
                                    color: #222;
                                    margin: 0;
                                    padding: 20px;
                                    background: #fff;
                                    -webkit-print-color-adjust: exact !important;
                                    print-color-adjust: exact !important;
                                }
                                .header {
                                    margin-bottom: 20px;
                                    border-bottom: 2px solid #b8860b;
                                    padding-bottom: 10px;
                                }
                                .devedor-nome {
                                    font-size: 20px;
                                    font-weight: bold;
                                    margin: 0 0 6px 0;
                                    color: #111;
                                }
                                .data-simulacao {
                                    font-size: 13px;
                                    color: #555;
                                    margin: 0;
                                }
                                .section-title {
                                    font-size: 14px;
                                    font-weight: bold;
                                    margin-top: 20px;
                                    margin-bottom: 10px;
                                    color: #333;
                                }
                                table {
                                    width: 100%;
                                    border-collapse: collapse;
                                    font-size: 13px;
                                    margin-bottom: 20px;
                                }
                                th {
                                    background-color: #b8860b;
                                    color: #ffffff;
                                    padding: 9px 10px;
                                    font-size: 11px;
                                    text-transform: uppercase;
                                    text-align: left;
                                    font-weight: bold;
                                    border: 1px solid #000;
                                }
                                th.right { text-align: right; }
                                td { border: 1px solid #ccc; }
                                .total-box {
                                    background-color: #f0f2f5;
                                    border: 1px solid #000;
                                    border-radius: 4px;
                                    padding: 12px 15px;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    font-size: 16px;
                                    font-weight: bold;
                                    margin-top: 20px;
                                }
                            </style>
                        </head>
                        <body>
                            <div class="header">
                                <div class="devedor-nome">${devedorNome}</div>
                                <div class="data-simulacao">${dataSimulacao}</div>
                            </div>

                            ${contratosRows ? `
                                <div class="section-title">Detalhamento por Contrato</div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Contrato / Parc.</th>
                                            <th class="right">Atraso</th>
                                            <th class="right">Original</th>
                                            <th class="right">Correção</th>
                                            <th class="right">Multa</th>
                                            <th class="right">Juros</th>
                                            <th class="right">Honorários</th>
                                            <th class="right">Atualizado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        ${contratosRows}
                                    </tbody>
                                    <tfoot>
                                        <tr style="font-weight: bold; background: #f0f2f5;">
                                            <td>Total</td>
                                            <td class="right">-</td>
                                            <td class="right">${toCurrency(simulacaoData.valorOriginal)}</td>
                                            <td class="right">+${toCurrency(simulacaoData.valorCorrecao || 0)}</td>
                                            <td class="right">+${toCurrency(simulacaoData.valorMulta)}</td>
                                            <td class="right">+${toCurrency(simulacaoData.valorJuros)}</td>
                                            <td class="right">+${toCurrency(simulacaoData.valorHonorarios)}</td>
                                            <td class="right">${toCurrency(simulacaoData.totalAtualizado)}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            ` : ''}

                            ${contratosRows ? '' : `
                            <div class="total-box">
                                <span>Total Atualizado</span>
                                <span>${toCurrency(simulacaoData.totalAtualizado)}</span>
                            </div>
                            `}
                        </body>
                        </html>
                    `;

                    printWindow.document.write(htmlContent);
                    printWindow.document.close();
                };

                return (
                    <Dialog
                        open={simulacaoOpen && !simulacaoMinimizada}
                        onClose={() => { setSimulacaoOpen(false); setSimulacaoMinimizada(false); }}
                        maxWidth="lg"
                        fullWidth
                        PaperProps={{
                            sx: {
                                maxWidth: "1280px",
                                width: "100%",
                                borderRadius: "12px"
                            }
                        }}
                    >
                        <DialogTitle sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <MDTypography variant="h6">Simulação de Campanha</MDTypography>
                            <MDBox display="flex" alignItems="center" gap={0.5}>
                                <IconButton size="small" onClick={handleMinimizarSimulacao} title="Minimizar">
                                    <Icon fontSize="small">remove</Icon>
                                </IconButton>
                                <IconButton size="small" onClick={() => { setSimulacaoOpen(false); setSimulacaoMinimizada(false); removeWindow(`simulacao-${recordId || "current"}`); }} title="Fechar">
                                    <Icon fontSize="small">close</Icon>
                                </IconButton>
                            </MDBox>
                        </DialogTitle>
                        <DialogContent dividers sx={{ p: 2 }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} mb={1}>
                                    {simulacaoData.devedorNome && (
                                        <MDTypography variant="h6" color={darkMode ? "white" : "dark"} fontWeight="medium">{simulacaoData.devedorNome}</MDTypography>
                                    )}
                                    <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                        <MDTypography variant="button" color="info" fontWeight="medium">Campanha Aplicada: {simulacaoData.campanhaNome}</MDTypography>
                                        {simulacaoData.criterioEnquadramento && (
                                            <MDBox
                                                component="span"
                                                sx={{
                                                    px: 1,
                                                    py: 0.2,
                                                    borderRadius: "4px",
                                                    bgcolor: darkMode ? "rgba(76, 175, 80, 0.2)" : "#e8f5e9",
                                                    border: darkMode ? "1px solid rgba(76, 175, 80, 0.4)" : "1px solid #c8e6c9",
                                                    color: darkMode ? "#81c784" : "#2e7d32",
                                                    fontSize: "11px",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                Critério: {simulacaoData.criterioEnquadramento}
                                            </MDBox>
                                        )}
                                    </MDBox>
                                    {simulacaoData.dataSimulacao ? (
                                        <MDTypography variant="caption" display="block" color="text">Simulação gerada para a data base: {simulacaoData.dataSimulacao}</MDTypography>
                                    ) : (
                                        <MDTypography variant="caption" display="block" color="text">Atraso: {simulacaoData.atrasoDias} dias</MDTypography>
                                    )}
                                </Grid>

                                {simulacaoData.contratosCalculadosList && simulacaoData.contratosCalculadosList.length > 0 ? (
                                    <Grid item xs={12} mb={1}>
                                        <MDTypography variant="caption" fontWeight="medium" mb={1} display="block">Detalhamento por Contrato</MDTypography>
                                        <TableContainer sx={{ border: "1px solid #f0f2f5", borderRadius: 2 }}>
                                            <Table size="small">
                                                <MDBox component="thead">
                                                    <TableRow>
                                                        <DataTableHeadCell width="auto" sorted={false} sx={{ whiteSpace: "nowrap" }}>Contrato / Parc.</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" align="right" sorted={false} sx={{ whiteSpace: "nowrap" }}>Atraso</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" align="right" sorted={false} sx={{ whiteSpace: "nowrap" }}>Original</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" align="right" sorted={false} sx={{ whiteSpace: "nowrap" }}>Correção</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" align="right" sorted={false} sx={{ whiteSpace: "nowrap" }}>Multa</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" align="right" sorted={false} sx={{ whiteSpace: "nowrap" }}>Juros</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" align="right" sorted={false} sx={{ whiteSpace: "nowrap" }}>Honorários</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" align="right" sorted={false} sx={{ whiteSpace: "nowrap" }}>Atualizado</DataTableHeadCell>
                                                    </TableRow>
                                                </MDBox>
                                                <TableBody>
                                                    {simulacaoData.contratosCalculadosList.map((c, idx) => (
                                                        <TableRow key={idx}>
                                                            <DataTableBodyCell isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                                <MDTypography variant="caption" color={darkMode ? "white" : "dark"}>{c.titulo} {c.parcela && c.parcela !== "Única" ? `(${c.parcela})` : ''}</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                                <MDTypography variant="caption" color={darkMode ? "white" : "dark"}>{c.atrasoDias} dias</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                                <MDTypography variant="caption" color={darkMode ? "white" : "dark"}>{toCurrency(c.valorOriginal)}</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                                <MDTypography variant="caption" sx={{ color: darkMode ? "#ffb74d" : "#ef6c00" }}>+{toCurrency(c.valorCorrecao || 0)}</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                                <MDTypography variant="caption" sx={{ color: darkMode ? "#ff7961" : "#d32f2f" }}>+{toCurrency(c.valorMulta)}</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                                <MDTypography variant="caption" sx={{ color: darkMode ? "#ff7961" : "#d32f2f" }}>+{toCurrency(c.valorJuros)}</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                                <MDTypography variant="caption" sx={{ color: darkMode ? "#ff7961" : "#d32f2f" }}>+{toCurrency(c.valorHonorarios)}</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                                <MDTypography variant="caption" fontWeight="medium" color={darkMode ? "white" : "dark"}>{toCurrency(c.totalAtualizado)}</MDTypography>
                                                            </DataTableBodyCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                                <MDBox component="tfoot">
                                                    <TableRow sx={{ backgroundColor: darkMode ? "#344767" : "#f0f2f5", borderTop: darkMode ? "2px solid #5a6a85" : "2px solid #e0e0e0" }}>
                                                        <DataTableBodyCell isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                            <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "dark"}>Total</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                            <MDTypography variant="caption" color="text">-</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                            <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "dark"}>{toCurrency(simulacaoData.valorOriginal)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                            <MDTypography variant="caption" fontWeight="bold" sx={{ color: darkMode ? "#ffb74d" : "#ef6c00" }}>+{toCurrency(simulacaoData.valorCorrecao || 0)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                            <MDTypography variant="caption" fontWeight="bold" sx={{ color: darkMode ? "#ff7961" : "#d32f2f" }}>+{toCurrency(simulacaoData.valorMulta)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                            <MDTypography variant="caption" fontWeight="bold" sx={{ color: darkMode ? "#ff7961" : "#d32f2f" }}>+{toCurrency(simulacaoData.valorJuros)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                            <MDTypography variant="caption" fontWeight="bold" sx={{ color: darkMode ? "#ff7961" : "#d32f2f" }}>+{toCurrency(simulacaoData.valorHonorarios)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true} sx={{ whiteSpace: "nowrap" }}>
                                                            <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "dark"}>{toCurrency(simulacaoData.totalAtualizado)}</MDTypography>
                                                        </DataTableBodyCell>
                                                    </TableRow>
                                                </MDBox>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                ) : (
                                    <>
                                        <Grid item xs={6} md>
                                            <MDTypography variant="caption" color="text">Valor Original</MDTypography>
                                            <MDTypography variant="caption" display="block" fontWeight="bold" color={darkMode ? "white" : "dark"}>{toCurrency(simulacaoData.valorOriginal)}</MDTypography>
                                        </Grid>
                                        <Grid item xs={6} md>
                                            <MDTypography variant="caption" color="text">Correção Monetária</MDTypography>
                                            <MDTypography variant="caption" display="block" fontWeight="bold" sx={{ color: darkMode ? "#ffb74d" : "#ef6c00" }}>+{toCurrency(simulacaoData.valorCorrecao || 0)}</MDTypography>
                                        </Grid>
                                        <Grid item xs={6} md>
                                            <MDTypography variant="caption" color="text">Multa ({simulacaoData.multaPercentual}%)</MDTypography>
                                            <MDTypography variant="caption" display="block" fontWeight="bold" sx={{ color: darkMode ? "#ff7961" : "#d32f2f" }}>+{toCurrency(simulacaoData.valorMulta)}</MDTypography>
                                        </Grid>
                                        <Grid item xs={6} md>
                                            <MDTypography variant="caption" color="text">Juros ({simulacaoData.jurosMensalPercentual}% a.m.)</MDTypography>
                                            <MDTypography variant="caption" display="block" fontWeight="bold" sx={{ color: darkMode ? "#ff7961" : "#d32f2f" }}>+{toCurrency(simulacaoData.valorJuros)}</MDTypography>
                                        </Grid>
                                        <Grid item xs={6} md>
                                            <MDTypography variant="caption" color="text">Honorários ({simulacaoData.honorariosPercentual}%)</MDTypography>
                                            <MDTypography variant="caption" display="block" fontWeight="bold" sx={{ color: darkMode ? "#ff7961" : "#d32f2f" }}>+{toCurrency(simulacaoData.valorHonorarios)}</MDTypography>
                                        </Grid>
                                    </>
                                )}

                                {!simulacaoData.contratosCalculadosList || simulacaoData.contratosCalculadosList.length === 0 ? (
                                    <Grid item xs={12}>
                                        <MDBox p={1} bgcolor={darkMode ? "#344767" : "#f0f2f5"} borderRadius={1} mt={1} display="flex" justifyContent="space-between" alignItems="center">
                                            <MDTypography variant="button" fontWeight="medium" color={darkMode ? "white" : "dark"}>Total Atualizado</MDTypography>
                                            <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>{toCurrency(simulacaoData.totalAtualizado)}</MDTypography>
                                        </MDBox>
                                    </Grid>
                                ) : null}

                                {simulacaoData.opcoesParcelamento && simulacaoData.opcoesParcelamento.length > 0 && (
                                    <Grid item xs={12} mt={2}>
                                        <MDTypography variant="caption" fontWeight="medium" mb={1} display="block">Opções de Parcelamento</MDTypography>
                                        <TableContainer sx={{ boxShadow: "none" }}>
                                            <Table size="small">
                                                <MDBox component="thead">
                                                    <TableRow>
                                                        <DataTableHeadCell width="auto" sorted={false}>Meio Pagto</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" sorted={false}>Parcelas</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" sorted={false}>Entrada (%)</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" sorted={false}>Desc. Principal</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" sorted={false}>Desc. Juros</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" sorted={false}>Desc. Multa</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" sorted={false}>Desc. Honorários</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" align="right" sorted={false}>Total a Pagar</DataTableHeadCell>
                                                        <DataTableHeadCell width="auto" align="center" sorted={false}>Ação</DataTableHeadCell>
                                                    </TableRow>
                                                </MDBox>
                                                <TableBody>
                                                    {simulacaoData.opcoesParcelamento.map((p, i) => (
                                                        <TableRow key={i}>
                                                            <DataTableBodyCell isProcess={true}>
                                                                <MDTypography variant="caption" fontWeight="medium" color={p.formaPagamentoDescricao && p.formaPagamentoDescricao !== "Todas" ? "info" : "text"}>
                                                                    {p.formaPagamentoDescricao || "Todas"}
                                                                </MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell isProcess={true}>
                                                                <MDTypography variant="caption" color="text">{p.parcelaMinima} a {p.parcelaMaxima}x</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell isProcess={true}>
                                                                <MDTypography variant="caption" fontWeight="bold" color="info">
                                                                    {p.percentualMinimoEntrada || p.percentualEntrada || 0}%
                                                                </MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell isProcess={true}>
                                                                <MDTypography variant="caption" color="text">{p.descontoPrincipal}%</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell isProcess={true}>
                                                                <MDTypography variant="caption" color="text">{p.descontoJuros}%</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell isProcess={true}>
                                                                <MDTypography variant="caption" color="text">{p.descontoMulta}%</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell isProcess={true}>
                                                                <MDTypography variant="caption" color="text">{p.descontoHonorarios}%</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell align="right" isProcess={true}>
                                                                <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "dark"}>{toCurrency(p.totalComDesconto)}</MDTypography>
                                                            </DataTableBodyCell>
                                                            <DataTableBodyCell align="center" isProcess={true}>
                                                                <MDButton size="small" color="info" variant="outlined" onClick={() => handleOpenAcordoModal(p)}>
                                                                    Gerar
                                                                </MDButton>
                                                            </DataTableBodyCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                )}

                                <Grid item xs={12} mt={2} display="flex" justifyContent="center">
                                    <MDButton
                                        size="small"
                                        color="info"
                                        variant={darkMode ? "contained" : "outlined"}
                                        onClick={handleOpenAcordoManual}
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        Nova Simulação Manual
                                    </MDButton>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions sx={{ p: 1 }}>
                            <MDButton
                                size="small"
                                color="info"
                                variant="contained"
                                onClick={handlePrintSimulacao}
                                startIcon={<Icon>print</Icon>}
                                sx={{ mr: 1 }}
                            >
                                Imprimir Cálculo
                            </MDButton>
                            <MDButton
                                size="small"
                                color={darkMode ? "white" : "secondary"}
                                onClick={() => { setSimulacaoOpen(false); setSimulacaoMinimizada(false); removeWindow(`simulacao-${recordId || "current"}`); }}
                            >
                                Fechar
                            </MDButton>
                        </DialogActions>
                    </Dialog>
                );
            })()}

            {/* Gerar Acordo Dialog */}
            <Dialog
                open={acordoModalOpen && !acordoMinimizado}
                onClose={() => { setAcordoModalOpen(false); setAcordoMinimizado(false); }}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    sx: {
                        backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                        backgroundImage: "none",
                        borderRadius: "12px",
                        overflow: "hidden"
                    }
                }}
            >
                <DialogTitle sx={{ p: 2.5, pb: 1.5, borderBottom: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #f0f2f5" }}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
                        <MDBox display="flex" alignItems="center" gap={1.5}>
                            <MDBox
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: "10px",
                                    backgroundColor: darkMode ? "rgba(25, 118, 210, 0.25)" : "#e3f2fd",
                                    color: darkMode ? "#64b5f6" : "#1976d2",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <Icon fontSize="medium">calendar_month</Icon>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="h6" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                    Gerar Acordo / Cronograma
                                </MDTypography>
                                <MDTypography variant="caption" color="text">
                                    Configure as condições abaixo para gerar o acordo.
                                </MDTypography>
                            </MDBox>
                        </MDBox>

                        <MDBox display="flex" alignItems="center" gap={1}>
                            {simulacaoData?.campanhaNome && (
                                <MDBox
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    px={1.5}
                                    py={0.8}
                                    borderRadius="md"
                                    sx={{
                                        backgroundColor: darkMode ? "rgba(33, 150, 243, 0.15)" : "#e3f2fd",
                                        border: darkMode ? "1px solid rgba(33, 150, 243, 0.3)" : "1px solid #bbdefb"
                                    }}
                                >
                                    <Icon fontSize="small" sx={{ color: darkMode ? "#64b5f6" : "#1976d2" }}>info</Icon>
                                    <MDTypography variant="caption" color={darkMode ? "white" : "dark"} sx={{ fontSize: "0.75rem" }}>
                                        Os limites e percentuais seguem as regras da campanha: <b>{simulacaoData.campanhaNome}</b>
                                        {simulacaoData.criterioEnquadramento && (
                                            <> · Enquadramento: <b>{simulacaoData.criterioEnquadramento}</b></>
                                        )}
                                    </MDTypography>
                                </MDBox>
                            )}

                            <MDBox display="flex" alignItems="center" gap={0.5} ml={1}>
                                <IconButton size="small" onClick={handleMinimizarAcordo} title="Minimizar">
                                    <Icon fontSize="small">remove</Icon>
                                </IconButton>
                                <IconButton size="small" onClick={() => { setAcordoModalOpen(false); setAcordoMinimizado(false); removeWindow(`acordo-${recordId || "current"}`); }} title="Fechar">
                                    <Icon fontSize="small">close</Icon>
                                </IconButton>
                            </MDBox>
                        </MDBox>
                    </MDBox>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2.5, backgroundColor: darkMode ? "#424550" : "#fafafa" }}>
                    {acordoOpcaoSelecionada && (() => {
                        const isAvista = Number(acordoQtdParcelas || 1) <= 1 && !acordoComEntrada;
                        const isCobextraCarteira = String(idDevedorCarteira) === "1" ||
                            (formRef?.current?.values?.idCarteira && String(formRef.current.values.idCarteira) === "1") ||
                            (formRef?.current?.values?.carteiraId && String(formRef.current.values.carteiraId) === "1") ||
                            contratos.some(c => String(c.idCarteira) === "1" || String(c.idDevedorCarteira) === "1" || String(c.carteiraId) === "1");

                        const descPrincipal = Number(regraCampanhaAtual?.descontoPrincipal || 0);
                        const descJuros = Number(regraCampanhaAtual?.descontoJuros || 0);
                        const descMulta = Number(regraCampanhaAtual?.descontoMulta || 0);
                        const descHonorarios = Number(regraCampanhaAtual?.descontoHonorarios || 0);
                        const hasHonorarios = descHonorarios > 0;
                        const allEqual = descPrincipal === descJuros && descPrincipal === descMulta && (!hasHonorarios || descPrincipal === descHonorarios);
                        const componentesIguais = ["Principal", "Juros", "Multa", hasHonorarios ? "Honorários" : null].filter(Boolean).join(" + ");

                        const opcoes = simulacaoData?.opcoesParcelamento || [];
                        const regraAvista = opcoes.find(r => r.parcelaMinima === 1 && r.parcelaMaxima === 1) || opcoes[0];
                        const regrasParceladas = opcoes.filter(r => r.parcelaMaxima > 1);
                        const descAvistaPct = regraAvista ? regraAvista.descontoPrincipal : descPrincipal;
                        const descParceladoPct = regrasParceladas.length > 0 ? Math.max(...regrasParceladas.map(r => r.descontoPrincipal)) : descPrincipal;

                        const totalAtualizado = valorIntegralCampanha || 0;
                        const valDigitado = valorDigitadoAcordo || 0;
                        let pctAplicado = 0;
                        if (totalAtualizado > 0) {
                            if (Math.abs(valDigitado - valorMinimoCampanha) < 0.05) {
                                pctAplicado = descPrincipal;
                            } else if (valDigitado >= totalAtualizado) {
                                pctAplicado = 0;
                            } else {
                                const ratio = (totalAtualizado - valDigitado) / (totalAtualizado - (valorMinimoCampanha || 1));
                                pctAplicado = Math.round(Math.max(0, Math.min(descPrincipal, ratio * descPrincipal)));
                            }
                        }

                        return (
                            <Grid container spacing={2}>
                                {/* Linha 1 - Coluna 1: Banner da Campanha */}
                                {simulacaoData && (
                                    <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                                        <MDBox
                                            p={2}
                                            borderRadius="lg"
                                            width="100%"
                                            display="flex"
                                            flexDirection="column"
                                            justifyContent="space-between"
                                            sx={{
                                                backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                                border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0",
                                                boxShadow: darkMode ? "0 2px 8px rgba(0,0,0,0.2)" : "0 2px 8px rgba(0,0,0,0.04)"
                                            }}
                                        >
                                            <MDBox>
                                                <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                                    <MDTypography variant="h6" fontWeight="bold" color={darkMode ? "white" : "dark"} sx={{ fontSize: "1rem" }}>
                                                        Campanha: {simulacaoData.campanhaNome || "Padrão"}
                                                    </MDTypography>
                                                    {simulacaoData.criterioEnquadramento && (
                                                        <MDBox
                                                            component="span"
                                                            sx={{
                                                                px: 1,
                                                                py: 0.2,
                                                                borderRadius: "4px",
                                                                bgcolor: darkMode ? "rgba(76, 175, 80, 0.2)" : "#e8f5e9",
                                                                border: darkMode ? "1px solid rgba(76, 175, 80, 0.4)" : "1px solid #c8e6c9",
                                                                color: darkMode ? "#81c784" : "#2e7d32",
                                                                fontSize: "11px",
                                                                fontWeight: "bold"
                                                            }}
                                                        >
                                                            Critério: {simulacaoData.criterioEnquadramento}
                                                        </MDBox>
                                                    )}
                                                </MDBox>
                                                {regraCampanhaAtual ? (
                                                    <>
                                                        <MDTypography variant="caption" color="text" display="block" sx={{ fontSize: "0.8rem", mt: 0.3 }}>
                                                            Faixa: <b>{totalParcelasConfiguradas}x</b> ({regraCampanhaAtual.parcelaMinima} a {regraCampanhaAtual.parcelaMaxima} parcelas) · {regraCampanhaAtual.formaPagamentoDescricao || "Todas"}
                                                        </MDTypography>
                                                        <MDTypography variant="caption" color="info" display="block" fontWeight="medium" sx={{ fontSize: "0.8rem", mt: 0.4 }}>
                                                            {allEqual ? (
                                                                <>Desconto máximo: <b>{descPrincipal}%</b> · {componentesIguais}</>
                                                            ) : (
                                                                <>Descontos máximos: Principal <b>{descPrincipal}%</b> · Juros <b>{descJuros}%</b> · Multa <b>{descMulta}%</b>{hasHonorarios ? <> · Honorários <b>{descHonorarios}%</b></> : null}</>
                                                            )}
                                                        </MDTypography>
                                                    </>
                                                ) : (
                                                    <MDTypography variant="caption" color={acordoIsExcecao ? "success" : "error"} display="block" fontWeight="bold" sx={{ mt: 0.5 }}>
                                                        {acordoIsExcecao
                                                            ? `✓ Parcelamento em ${totalParcelasConfiguradas}x para ${acordoFormaPagamento} liberado como Exceção.`
                                                            : `⚠️ A campanha não prevê parcelamento em ${totalParcelasConfiguradas}x para ${acordoFormaPagamento}${maxParcelasCampanhaForma > 0 ? ` (máximo permitido: ${maxParcelasCampanhaForma}x)` : ""}.`
                                                        }
                                                    </MDTypography>
                                                )}
                                            </MDBox>

                                            {regraCampanhaAtual && (
                                                <MDBox mt={1.5}>
                                                    {allEqual ? (
                                                        <MDBox
                                                            px={2}
                                                            py={1}
                                                            borderRadius="md"
                                                            textAlign="center"
                                                            sx={{
                                                                backgroundColor: darkMode ? "rgba(0, 230, 118, 0.15)" : "#e8f5e9",
                                                                border: darkMode ? "1px solid rgba(0, 230, 118, 0.3)" : "1px solid #c8e6c9"
                                                            }}
                                                        >
                                                            <MDTypography variant="h5" fontWeight="bold" sx={{ color: darkMode ? "#00e676" : "#2e7d32", lineHeight: 1.1 }}>
                                                                {descPrincipal}%
                                                            </MDTypography>
                                                            <MDTypography variant="caption" color="text" sx={{ fontSize: "0.72rem", fontWeight: "medium" }}>
                                                                Desconto Geral ({componentesIguais})
                                                            </MDTypography>
                                                        </MDBox>
                                                    ) : (
                                                        <MDBox display="flex" gap={1} alignItems="center">
                                                            <MDBox textAlign="center" px={1} py={0.8} borderRadius="md" sx={{ backgroundColor: darkMode ? "#424550" : "#f1f5f9", border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0", flex: 1 }}>
                                                                <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"} sx={{ fontSize: "0.95rem" }}>{descPrincipal}%</MDTypography>
                                                                <MDTypography variant="caption" color="text" display="block" sx={{ fontSize: "0.68rem" }}>Principal</MDTypography>
                                                            </MDBox>
                                                            <MDBox textAlign="center" px={1} py={0.8} borderRadius="md" sx={{ backgroundColor: darkMode ? "#424550" : "#f1f5f9", border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0", flex: 1 }}>
                                                                <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"} sx={{ fontSize: "0.95rem" }}>{descJuros}%</MDTypography>
                                                                <MDTypography variant="caption" color="text" display="block" sx={{ fontSize: "0.68rem" }}>Juros</MDTypography>
                                                            </MDBox>
                                                            <MDBox textAlign="center" px={1} py={0.8} borderRadius="md" sx={{ backgroundColor: darkMode ? "#424550" : "#f1f5f9", border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0", flex: 1 }}>
                                                                <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"} sx={{ fontSize: "0.95rem" }}>{descMulta}%</MDTypography>
                                                                <MDTypography variant="caption" color="text" display="block" sx={{ fontSize: "0.68rem" }}>Multa</MDTypography>
                                                            </MDBox>
                                                            {hasHonorarios && (
                                                                <MDBox textAlign="center" px={1} py={0.8} borderRadius="md" sx={{ backgroundColor: darkMode ? "#424550" : "#f1f5f9", border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0", flex: 1 }}>
                                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"} sx={{ fontSize: "0.95rem" }}>{descHonorarios}%</MDTypography>
                                                                    <MDTypography variant="caption" color="text" display="block" sx={{ fontSize: "0.68rem" }}>Honorários</MDTypography>
                                                                </MDBox>
                                                            )}
                                                        </MDBox>
                                                    )}
                                                </MDBox>
                                            )}

                                            <MDBox mt={2} pt={1} sx={{ borderTop: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #e2e8f0" }}>
                                                <MDTypography variant="caption" color="text" sx={{ fontSize: "0.75rem" }}>
                                                    Regra configurada para {totalParcelasConfiguradas} parcela(s).
                                                </MDTypography>
                                            </MDBox>
                                        </MDBox>
                                    </Grid>
                                )}

                                {/* Linha 1 - Coluna 2: Faixa de Negociação (ao lado de Campanha) */}
                                <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                                    <MDBox
                                        p={2}
                                        borderRadius="lg"
                                        width="100%"
                                        display="flex"
                                        flexDirection="column"
                                        justifyContent="space-between"
                                        sx={{
                                            height: "100%",
                                            backgroundColor: darkMode ? "#4B4F5C" : "#f2f9f6",
                                            border: darkMode ? "1px solid #606472" : "1px solid #c8e6c9",
                                            boxShadow: darkMode ? "0 2px 8px rgba(0,0,0,0.2)" : "0 2px 8px rgba(0,0,0,0.04)"
                                        }}
                                    >
                                        <MDBox>
                                            <MDBox display="flex" alignItems="center" gap={1} mb={1.5}>
                                                <MDBox
                                                    sx={{
                                                        width: 28,
                                                        height: 28,
                                                        borderRadius: "50%",
                                                        backgroundColor: darkMode ? "rgba(0, 230, 118, 0.2)" : "#e8f5e9",
                                                        color: darkMode ? "#00e676" : "#2e7d32",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontWeight: "bold",
                                                        fontSize: "0.85rem"
                                                    }}
                                                >
                                                    $
                                                </MDBox>
                                                <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"} sx={{ fontSize: "0.9rem" }}>
                                                    Faixa de negociação (valor total)
                                                </MDTypography>
                                            </MDBox>

                                            <MDBox
                                                p={1.5}
                                                borderRadius="md"
                                                sx={{
                                                    backgroundColor: darkMode ? "#424550" : "#ffffff",
                                                    border: darkMode ? "1px solid #606472" : "1px solid #d7ecd9"
                                                }}
                                            >
                                                <Grid container spacing={1}>
                                                    <Grid item xs={6} textAlign="center" sx={{ borderRight: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #e0f0e3" }}>
                                                        <MDTypography variant="caption" color="text" display="block" sx={{ fontSize: "0.75rem" }}>Valor mínimo</MDTypography>
                                                        <MDTypography variant="h6" fontWeight="bold" sx={{ color: darkMode ? "#00e676" : "#2e7d32", fontSize: "1.1rem" }}>
                                                            {toCurrency(valorMinimoCampanha)}
                                                        </MDTypography>
                                                        <MDTypography variant="caption" sx={{ color: darkMode ? "#81c784" : "#388e3c", fontSize: "0.7rem", fontWeight: "medium" }}>
                                                            ({descPrincipal}% de desconto)
                                                        </MDTypography>
                                                    </Grid>
                                                    <Grid item xs={6} textAlign="center">
                                                        <MDTypography variant="caption" color="text" display="block" sx={{ fontSize: "0.75rem" }}>Valor máximo</MDTypography>
                                                        <MDTypography variant="h6" fontWeight="bold" color={darkMode ? "white" : "dark"} sx={{ fontSize: "1.1rem" }}>
                                                            {toCurrency(valorIntegralCampanha)}
                                                        </MDTypography>
                                                        <MDTypography variant="caption" color="text" sx={{ fontSize: "0.7rem" }}>
                                                            (sem desconto)
                                                        </MDTypography>
                                                    </Grid>
                                                </Grid>
                                            </MDBox>
                                        </MDBox>

                                        <MDBox mt="auto" pt={1.5} sx={{ borderTop: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #d7ecd9" }}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={6}>
                                                    <MDTypography variant="caption" color="text" display="block" sx={{ fontSize: "0.75rem", fontWeight: "medium" }}>À vista</MDTypography>
                                                    <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="bold" sx={{ fontSize: "0.8rem" }}>
                                                        {descAvistaPct}% de desconto
                                                    </MDTypography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <MDTypography variant="caption" color="text" display="block" sx={{ fontSize: "0.75rem", fontWeight: "medium" }}>Parcelado</MDTypography>
                                                    <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="bold" sx={{ fontSize: "0.8rem" }}>
                                                        {descParceladoPct}% de desconto
                                                    </MDTypography>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    </MDBox>
                                </Grid>

                                {/* Linha 2 - Coluna 1: Etapa 1 - Valor Negociado */}
                                <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                                    <MDBox
                                        p={2}
                                        borderRadius="lg"
                                        width="100%"
                                        display="flex"
                                        flexDirection="column"
                                        justifyContent="space-between"
                                        sx={{
                                            height: "100%",
                                            backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                            border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0",
                                            boxShadow: darkMode ? "0 2px 8px rgba(0,0,0,0.2)" : "0 2px 8px rgba(0,0,0,0.04)"
                                        }}
                                    >
                                        <MDBox>
                                            <MDBox display="flex" alignItems="center" gap={1.2} mb={2}>
                                                <MDBox
                                                    sx={{
                                                        width: 26,
                                                        height: 26,
                                                        borderRadius: "50%",
                                                        backgroundColor: "#1976d2",
                                                        color: "#ffffff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "0.75rem",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    1
                                                </MDBox>
                                                <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                    Valor negociado
                                                </MDTypography>
                                                <MDBox
                                                    px={1.2}
                                                    py={0.3}
                                                    borderRadius="md"
                                                    sx={{
                                                        backgroundColor: darkMode ? "rgba(33, 150, 243, 0.2)" : "#e3f2fd",
                                                        border: darkMode ? "1px solid #64b5f6" : "1px solid #90caf9"
                                                    }}
                                                >
                                                    <MDTypography variant="caption" fontWeight="bold" sx={{ color: darkMode ? "#90caf9" : "#1565c0", fontSize: "0.75rem" }}>
                                                        {pctAplicado}% desc.
                                                    </MDTypography>
                                                </MDBox>
                                            </MDBox>

                                            {/* Slider Interativo */}
                                            {acordoOpcaoSelecionada.isManual && valorIntegralCampanha > 0 && (
                                                <MDBox px={1} mb={2}>
                                                    <Slider
                                                        min={valorMinimoCampanha || 0}
                                                        max={Math.max(valorIntegralCampanha, (valorMinimoCampanha || 0) + 1)}
                                                        step={1}
                                                        value={Math.max(valorMinimoCampanha || 0, Math.min(valorIntegralCampanha || 0, valDigitado))}
                                                        onChange={(e, val) => setAcordoValorManual(formatCurrencyInput(val))}
                                                        sx={{
                                                            color: "#00e676",
                                                            height: 6,
                                                            "& .MuiSlider-track": {
                                                                background: "linear-gradient(90deg, #00e676 0%, #29b6f6 100%)",
                                                                border: "none"
                                                            },
                                                            "& .MuiSlider-rail": {
                                                                backgroundColor: darkMode ? "#606472" : "#e2e8f0",
                                                                opacity: 1
                                                            },
                                                            "& .MuiSlider-thumb": {
                                                                height: 20,
                                                                width: 20,
                                                                backgroundColor: "#ffffff",
                                                                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                                                                border: "2px solid #29b6f6",
                                                                "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
                                                                    boxShadow: "0 0 0 8px rgba(41, 182, 246, 0.2)"
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <MDBox display="flex" justifyContent="space-between" mt={-0.5}>
                                                        <Tooltip title="Clique para aplicar o Valor Mínimo com Desconto Máximo">
                                                            <MDTypography
                                                                variant="caption"
                                                                sx={{
                                                                    cursor: "pointer",
                                                                    color: darkMode ? "#81c784" : "#2e7d32",
                                                                    fontWeight: "bold",
                                                                    fontSize: "0.75rem"
                                                                }}
                                                                onClick={() => setAcordoValorManual(formatCurrencyInput(valorMinimoCampanha))}
                                                            >
                                                                {toCurrency(valorMinimoCampanha)}
                                                            </MDTypography>
                                                        </Tooltip>
                                                        <Tooltip title="Clique para aplicar o Valor Integral Sem Desconto">
                                                            <MDTypography
                                                                variant="caption"
                                                                sx={{
                                                                    cursor: "pointer",
                                                                    color: "text",
                                                                    fontWeight: "bold",
                                                                    fontSize: "0.75rem"
                                                                }}
                                                                onClick={() => {
                                                                    setAcordoValorManual(formatCurrencyInput(valorIntegralCampanha));
                                                                    invalidateCronograma();
                                                                }}
                                                            >
                                                                {toCurrency(valorIntegralCampanha)}
                                                            </MDTypography>
                                                        </Tooltip>
                                                    </MDBox>
                                                </MDBox>
                                            )}

                                            {/* Campo de Entrada de Valor posicionado abaixo da barra */}
                                            <MDBox
                                                p={1.5}
                                                borderRadius="md"
                                                sx={{
                                                    backgroundColor: darkMode ? "#424550" : "#f8f9fa",
                                                    border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0"
                                                }}
                                            >
                                                <Grid container spacing={1.5} alignItems="center" justifyContent="space-between">
                                                    <Grid item xs={12} sm={6.5}>
                                                        <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"} sx={{ fontSize: "0.9rem" }}>
                                                            Entre com o valor negociado:
                                                        </MDTypography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={5.5} textAlign="right">
                                                        {acordoOpcaoSelecionada.isManual ? (
                                                            <MDInput
                                                                type="text"
                                                                value={acordoValorManual}
                                                                onChange={(e) => {
                                                                    setAcordoValorManual(formatCurrencyInput(e.target.value));
                                                                    invalidateCronograma();
                                                                }}
                                                                error={isValorAbaixoCampanha}
                                                                placeholder="R$ 0,00"
                                                                fullWidth
                                                                sx={{
                                                                    "& .MuiInputBase-input": {
                                                                        fontSize: "1.1rem",
                                                                        fontWeight: "bold",
                                                                        textAlign: "right",
                                                                        color: isValorAbaixoCampanha
                                                                            ? (darkMode ? "#ff5252 !important" : "#d32f2f !important")
                                                                            : (darkMode ? "#ffffff !important" : "#1a2035 !important")
                                                                    },
                                                                    "& .MuiInputBase-root": {
                                                                        height: "40px",
                                                                        minHeight: "40px",
                                                                        backgroundColor: isValorAbaixoCampanha
                                                                            ? (darkMode ? "rgba(244, 67, 54, 0.18)" : "#fff5f5")
                                                                            : (darkMode ? "#4B4F5C" : "#ffffff"),
                                                                        border: isValorAbaixoCampanha
                                                                            ? "1px solid #f44336 !important"
                                                                            : (darkMode ? "1px solid #606472" : "1px solid #d2d6da"),
                                                                        borderRadius: "8px",
                                                                        boxShadow: isValorAbaixoCampanha ? "0 0 6px rgba(244, 67, 54, 0.35)" : "none"
                                                                    },
                                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: isValorAbaixoCampanha ? "#f44336 !important" : "inherit"
                                                                    }
                                                                }}
                                                            />
                                                        ) : (
                                                            <MDTypography variant="h6" fontWeight="bold" color="info">
                                                                {toCurrency(acordoOpcaoSelecionada.totalComDesconto)}
                                                            </MDTypography>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </MDBox>
                                        </MDBox>

                                        <MDBox mt={2}>
                                            {isValorAbaixoCampanha && (
                                                <MDTypography variant="caption" color="error" fontWeight="bold" display="block">
                                                    ⚠️ Valor abaixo do permitido pela campanha (Mínimo: {toCurrency(valorMinimoCampanha)}). Para valores menores, ative &quot;Liberar como Exceção&quot;.
                                                </MDTypography>
                                            )}
                                            {acordoIsExcecao && valorDigitadoAcordo < (valorMinimoCampanha - 0.05) && (
                                                <MDTypography variant="caption" sx={{ color: darkMode ? "#81c784" : "#2e7d32", fontWeight: "bold", display: "block" }}>
                                                    ✓ Valor abaixo do mínimo da campanha liberado como Exceção.
                                                </MDTypography>
                                            )}
                                            {isParcelasForaCampanha && (
                                                <MDTypography variant="caption" color="error" fontWeight="bold" display="block">
                                                    ⚠️ Parcelamento em {totalParcelasConfiguradas}x não permitido para {acordoFormaPagamento} pela campanha{maxParcelasCampanhaForma > 0 ? ` (máximo permitido: ${maxParcelasCampanhaForma}x)` : ""}. Para prosseguir, altere a forma de pagamento ou ative &quot;Liberar como Exceção&quot;.
                                                </MDTypography>
                                            )}
                                            {acordoIsExcecao && !regraCampanhaAtual && (
                                                <MDTypography variant="caption" sx={{ color: darkMode ? "#81c784" : "#2e7d32", fontWeight: "bold", display: "block" }}>
                                                    ✓ Parcelamento em {totalParcelasConfiguradas}x para {acordoFormaPagamento} liberado como Exceção da Campanha.
                                                </MDTypography>
                                            )}
                                        </MDBox>
                                    </MDBox>
                                </Grid>

                                {/* Linha 2 - Coluna 2: Etapa 2 - Condições do Acordo */}
                                <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                                    <MDBox
                                        p={2}
                                        borderRadius="lg"
                                        width="100%"
                                        display="flex"
                                        flexDirection="column"
                                        justifyContent="space-between"
                                        sx={{
                                            height: "100%",
                                            backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                            border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0",
                                            boxShadow: darkMode ? "0 2px 8px rgba(0,0,0,0.2)" : "0 2px 8px rgba(0,0,0,0.04)"
                                        }}
                                    >
                                        <MDBox>
                                            <MDBox display="flex" alignItems="center" gap={1.2} mb={1.5}>
                                                <MDBox
                                                    sx={{
                                                        width: 26,
                                                        height: 26,
                                                        borderRadius: "50%",
                                                        backgroundColor: "#1976d2",
                                                        color: "#ffffff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "0.75rem",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    2
                                                </MDBox>
                                                <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                    Condições do acordo
                                                </MDTypography>
                                            </MDBox>

                                            <Grid container spacing={1.5} alignItems="center">
                                                {/* Modalidade: À vista vs Parcelado */}
                                                <Grid item xs={12}>
                                                    <InputLabel sx={{ px: 0.5, pb: 0.3, pt: 0, fontSize: "0.75rem" }}>Forma de Pagamento</InputLabel>
                                                    <MDBox display="flex" gap={1} height="38px" alignItems="center">
                                                        <Box
                                                            onClick={() => {
                                                                setAcordoQtdParcelas(1);
                                                                setAcordoComEntrada(false);
                                                                setAcordoPeriodicidade(30);
                                                                invalidateCronograma();
                                                            }}
                                                            sx={{
                                                                flex: 1,
                                                                height: "38px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: 0.8,
                                                                borderRadius: "8px",
                                                                cursor: "pointer",
                                                                border: "1px solid",
                                                                borderColor: isAvista ? "#1976d2" : (darkMode ? "#4f5361" : "#cfd8dc"),
                                                                backgroundColor: isAvista ? (darkMode ? "rgba(25, 118, 210, 0.2)" : "#e3f2fd") : "rgba(0, 0, 0, 0)",
                                                                transition: "all 150ms ease-in-out"
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    width: 14,
                                                                    height: 14,
                                                                    borderRadius: "50%",
                                                                    border: `2px solid ${isAvista ? "#1976d2" : "#9e9e9e"}`,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center"
                                                                }}
                                                            >
                                                                {isAvista && <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#1976d2" }} />}
                                                            </Box>
                                                            <MDTypography variant="button" fontWeight={isAvista ? "bold" : "regular"} color={isAvista ? "info" : "text"} sx={{ fontSize: "0.8rem" }}>
                                                                À vista
                                                            </MDTypography>
                                                        </Box>

                                                        <Box
                                                            onClick={() => {
                                                                if (Number(acordoQtdParcelas) <= 1) {
                                                                    setAcordoQtdParcelas(2);
                                                                }
                                                                invalidateCronograma();
                                                            }}
                                                            sx={{
                                                                flex: 1,
                                                                height: "38px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: 0.8,
                                                                borderRadius: "8px",
                                                                cursor: "pointer",
                                                                border: "1px solid",
                                                                borderColor: !isAvista ? "#1976d2" : (darkMode ? "#4f5361" : "#cfd8dc"),
                                                                backgroundColor: !isAvista ? (darkMode ? "rgba(25, 118, 210, 0.2)" : "#e3f2fd") : "rgba(0, 0, 0, 0)",
                                                                transition: "all 150ms ease-in-out"
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    width: 14,
                                                                    height: 14,
                                                                    borderRadius: "50%",
                                                                    border: `2px solid ${!isAvista ? "#1976d2" : "#9e9e9e"}`,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center"
                                                                }}
                                                            >
                                                                {!isAvista && <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#1976d2" }} />}
                                                            </Box>
                                                            <MDTypography variant="button" fontWeight={!isAvista ? "bold" : "regular"} color={!isAvista ? "info" : "text"} sx={{ fontSize: "0.8rem" }}>
                                                                Parcelado
                                                            </MDTypography>
                                                        </Box>
                                                    </MDBox>
                                                </Grid>

                                                {/* Periodicidade */}
                                                <Grid item xs={6}>
                                                    <InputLabel sx={{ px: 0.5, pb: 0.3, pt: 0, fontSize: "0.75rem" }}>Periodicidade (dias)</InputLabel>
                                                    <MDInput
                                                        type="number"
                                                        value={acordoPeriodicidade}
                                                        onChange={(e) => {
                                                            setAcordoPeriodicidade(e.target.value);
                                                            invalidateCronograma();
                                                        }}
                                                        fullWidth
                                                        sx={{ "& .MuiInputBase-root": { height: "38px", minHeight: "38px" } }}
                                                    />
                                                </Grid>

                                                {/* Qtd. Parcelas */}
                                                <Grid item xs={6}>
                                                    <InputLabel sx={{ px: 0.5, pb: 0.3, pt: 0, fontSize: "0.75rem" }}>Qtd. Parcelas</InputLabel>
                                                    <MDInput
                                                        type="number"
                                                        value={acordoQtdParcelas}
                                                        disabled={isAvista}
                                                        onChange={(e) => {
                                                            const rawVal = parseInt(e.target.value, 10);
                                                            if (isNaN(rawVal)) {
                                                                setAcordoQtdParcelas("");
                                                                invalidateCronograma();
                                                                return;
                                                            }
                                                            const maxVal = acordoIsExcecao ? 999 : (maxParcelasCampanhaForma > 0 ? maxParcelasCampanhaForma : 999);
                                                            const newQtd = Math.max(1, Math.min(maxVal, rawVal));
                                                            setAcordoQtdParcelas(newQtd);
                                                            invalidateCronograma();
                                                        }}
                                                        inputProps={{ min: 1, max: acordoIsExcecao ? 999 : (maxParcelasCampanhaForma > 0 ? maxParcelasCampanhaForma : 999) }}
                                                        error={isParcelasForaCampanha}
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-root": {
                                                                height: "38px",
                                                                minHeight: "38px",
                                                                backgroundColor: isParcelasForaCampanha
                                                                    ? (darkMode ? "rgba(244, 67, 54, 0.18)" : "#fff5f5")
                                                                    : "inherit",
                                                                border: isParcelasForaCampanha
                                                                    ? "1px solid #f44336 !important"
                                                                    : "inherit"
                                                            }
                                                        }}
                                                    />
                                                </Grid>

                                                {/* Primeiro Vencimento */}
                                                <Grid item xs={6}>
                                                    <InputLabel sx={{ px: 0.5, pb: 0.3, pt: 0, fontSize: "0.75rem" }}>Primeiro Vencimento</InputLabel>
                                                    <MDInput
                                                        type="date"
                                                        value={acordoPrimeiroVencimento}
                                                        onChange={(e) => handleChangePrimeiroVencimento(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        fullWidth
                                                        sx={{ "& .MuiInputBase-root": { height: "38px", minHeight: "38px" } }}
                                                    />
                                                </Grid>

                                                {/* Meio de Pagamento */}
                                                <Grid item xs={6}>
                                                    <InputLabel sx={{ px: 0.5, pb: 0.3, pt: 0, fontSize: "0.75rem" }}>Meio de Liquidação</InputLabel>
                                                    <MDInput
                                                        select
                                                        value={acordoFormaPagamento}
                                                        onChange={(e) => {
                                                            const novaForma = e.target.value;
                                                            setAcordoFormaPagamento(novaForma);
                                                            invalidateCronograma();
                                                            if (!acordoIsExcecao) {
                                                                const regrasNova = (simulacaoData?.opcoesParcelamento || []).filter(r => 
                                                                    !r.formaPagamentoDescricao || r.formaPagamentoDescricao === "Todas" || r.formaPagamentoDescricao === novaForma
                                                                );
                                                                const maxNova = regrasNova.length > 0 
                                                                    ? Math.max(...regrasNova.map(r => Number(r.parcelaMaxima) || 1))
                                                                    : 0;
                                                                if (maxNova > 0 && Number(acordoQtdParcelas) > maxNova) {
                                                                    setAcordoQtdParcelas(maxNova);
                                                                }
                                                            }
                                                        }}
                                                        fullWidth
                                                        sx={{ "& .MuiInputBase-root": { height: "38px", minHeight: "38px" } }}
                                                    >
                                                        <MenuItem value="Boleto">Boleto</MenuItem>
                                                        <MenuItem value="Pix">Pix</MenuItem>
                                                        <MenuItem value="Depósito">Depósito/Transferência</MenuItem>
                                                        <MenuItem value="Cartão de Crédito">Cartão de Crédito</MenuItem>
                                                        <MenuItem value="Dinheiro">Dinheiro</MenuItem>
                                                        <MenuItem value="Pagto no Credor">Pagto no Credor</MenuItem>
                                                    </MDInput>
                                                </Grid>

                                                {/* Switches no layout padrão do sistema */}
                                                <Grid item xs={12} sm={!isAvista && !isCobextraCarteira ? 6 : 12} display="flex" alignItems="center" pt={1}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={acordoIsExcecao}
                                                                onChange={(e) => {
                                                                    setAcordoIsExcecao(e.target.checked);
                                                                    invalidateCronograma();
                                                                }}
                                                                color="info"
                                                            />
                                                        }
                                                        label={
                                                            <MDTypography
                                                                variant="button"
                                                                fontWeight="medium"
                                                                color={darkMode ? "white" : "dark"}
                                                                sx={{ fontSize: "0.85rem", cursor: "pointer", userSelect: "none" }}
                                                            >
                                                                Liberar como Exceção da Campanha
                                                            </MDTypography>
                                                        }
                                                        sx={{ margin: 0 }}
                                                    />
                                                </Grid>

                                                {!isAvista && !isCobextraCarteira && (
                                                    <Grid item xs={12} sm={acordoOpcaoSelecionada.isManual ? 6 : 12} display="flex" alignItems="center" pt={1}>
                                                        <FormControlLabel
                                                            control={
                                                                <Switch
                                                                    checked={acordoComEntrada}
                                                                    onChange={(e) => {
                                                                        setAcordoComEntrada(e.target.checked);
                                                                        invalidateCronograma();
                                                                    }}
                                                                    color="info"
                                                                />
                                                            }
                                                            label={
                                                                <MDTypography
                                                                    variant="button"
                                                                    fontWeight="medium"
                                                                    color={darkMode ? "white" : "dark"}
                                                                    sx={{ fontSize: "0.85rem", cursor: "pointer", userSelect: "none" }}
                                                                >
                                                                    Possui Pagamento de Entrada?
                                                                </MDTypography>
                                                            }
                                                            sx={{ margin: 0 }}
                                                        />
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </MDBox>

                                        <MDBox>

                                            {/* Seção Parcelado com Entrada */}
                                            {!isAvista && acordoComEntrada && !isCobextraCarteira && (
                                                <MDBox mt={1.5} p={1.5} borderRadius="md" sx={{ backgroundColor: darkMode ? "#424550" : "#f8f9fa", border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0" }}>
                                                    <Grid container spacing={1.5}>
                                                        <Grid item xs={12} sm={parseInt(acordoQtdEntrada) > 1 ? 4 : 4}>
                                                            <MDInput type="text" label="Valor Entrada" value={acordoValorEntrada} onChange={(e) => handleMainValorEntradaChange(e.target.value)} fullWidth size="small" />
                                                        </Grid>
                                                        <Grid item xs={12} sm={parseInt(acordoQtdEntrada) > 1 ? 4 : 4}>
                                                            <MDInput type="number" label="Qtd Parc. Entrada" value={acordoQtdEntrada} onChange={(e) => {
                                                                setAcordoQtdEntrada(Math.max(1, parseInt(e.target.value) || 1));
                                                                invalidateCronograma();
                                                            }} fullWidth size="small" />
                                                        </Grid>
                                                        <Grid item xs={12} sm={parseInt(acordoQtdEntrada) > 1 ? 4 : 4}>
                                                            <MDInput type="date" label="Venc. Entrada" value={acordoVencimentoEntrada} onChange={(e) => {
                                                                setAcordoVencimentoEntrada(e.target.value);
                                                                invalidateCronograma();
                                                            }} InputLabelProps={{ shrink: true }} fullWidth size="small" />
                                                        </Grid>
                                                        {parseInt(acordoQtdEntrada) === 1 && (
                                                            <Grid item xs={12} display="flex" alignItems="center">
                                                                <FormControlLabel
                                                                    control={
                                                                        <Switch
                                                                            checked={acordoMleList[0] || false}
                                                                            onChange={(e) => {
                                                                                setAcordoMleList([e.target.checked]);
                                                                                invalidateCronograma();
                                                                            }}
                                                                            color="info"
                                                                            size="small"
                                                                        />
                                                                    }
                                                                    label={<MDTypography variant="caption" color="text">MLE</MDTypography>}
                                                                />
                                                            </Grid>
                                                        )}

                                                        {parseInt(acordoQtdEntrada) > 1 && acordoEntradasDetalhadas.length > 0 && (
                                                            <Grid item xs={12}>
                                                                <MDTypography variant="caption" fontWeight="medium" display="block" mb={1} sx={{ opacity: 0.8 }}>
                                                                    Detalhamento das Parcelas de Entrada:
                                                                </MDTypography>
                                                                <Grid container spacing={1} sx={{ pl: 1, borderLeft: "3px solid #1A73E8", my: 0.5 }}>
                                                                    {acordoEntradasDetalhadas.map((ent, idx) => (
                                                                        <React.Fragment key={idx}>
                                                                            <Grid item xs={12} sm={3} display="flex" alignItems="center">
                                                                                <MDTypography variant="button" fontWeight="medium" size="small">
                                                                                    Entrada {idx + 1}
                                                                                </MDTypography>
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={3}>
                                                                                <MDInput
                                                                                    type="text"
                                                                                    label="Valor"
                                                                                    value={ent.valor}
                                                                                    onChange={(e) => {
                                                                                        let newList = [...acordoEntradasDetalhadas];
                                                                                        newList[idx].valor = formatCurrencyInput(e.target.value);
                                                                                        setAcordoEntradasDetalhadas(newList);
                                                                                        let sum = 0;
                                                                                        for (let item of newList) {
                                                                                            sum += (formatUncurrency(item.valor) || 0);
                                                                                        }
                                                                                        setAcordoValorEntrada(formatCurrencyInput(sum));
                                                                                        invalidateCronograma();
                                                                                    }}
                                                                                    fullWidth
                                                                                    size="small"
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={3}>
                                                                                <MDInput
                                                                                    type="date"
                                                                                    label="Vencimento"
                                                                                    value={ent.vencimento}
                                                                                    onChange={(e) => {
                                                                                        let newList = [...acordoEntradasDetalhadas];
                                                                                        newList[idx].vencimento = e.target.value;
                                                                                        setAcordoEntradasDetalhadas(newList);
                                                                                        invalidateCronograma();
                                                                                    }}
                                                                                    InputLabelProps={{ shrink: true }}
                                                                                    fullWidth
                                                                                    size="small"
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={3} display="flex" alignItems="center">
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Switch
                                                                                            checked={acordoMleList[idx] || false}
                                                                                            onChange={(e) => {
                                                                                                const newMle = [...acordoMleList];
                                                                                                newMle[idx] = e.target.checked;
                                                                                                setAcordoMleList(newMle);
                                                                                                invalidateCronograma();
                                                                                            }}
                                                                                            color="info"
                                                                                            size="small"
                                                                                        />
                                                                                    }
                                                                                    label={<MDTypography variant="caption" color="text">MLE</MDTypography>}
                                                                                />
                                                                            </Grid>
                                                                        </React.Fragment>
                                                                    ))}
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </MDBox>
                                            )}
                                        </MDBox>
                                    </MDBox>
                                </Grid>

                                {/* Linha 3: Cronograma de Pagamento (Exibido apenas quando for parcelar) */}
                                {!isAvista && (
                                    <Grid item xs={12}>
                                        <MDBox
                                            p={2}
                                            borderRadius="lg"
                                            sx={{
                                                backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                                border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0",
                                                boxShadow: darkMode ? "0 2px 8px rgba(0,0,0,0.2)" : "0 2px 8px rgba(0,0,0,0.04)"
                                            }}
                                        >
                                            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1.5} flexWrap="wrap" gap={1}>
                                                <MDBox display="flex" alignItems="center" gap={1}>
                                                    <Icon color="info" fontSize="medium">calendar_today</Icon>
                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"} sx={{ fontSize: "0.95rem" }}>
                                                        Cronograma de Pagamento ({totalParcelasConfiguradas} parcelas)
                                                    </MDTypography>
                                                </MDBox>
                                                <MDBox display="flex" gap={1}>
                                                    <MDButton
                                                        variant="contained"
                                                        color="info"
                                                        size="small"
                                                        onClick={handleCalcularCronograma}
                                                        disabled={isBloqueadoPorRegra}
                                                        startIcon={<Icon>calculate</Icon>}
                                                    >
                                                        Calcular Parcelas
                                                    </MDButton>
                                                    {acordoParcelasGeradas.length > 0 && (
                                                        <MDButton
                                                            variant="outlined"
                                                            color="info"
                                                            size="small"
                                                            startIcon={<Icon>print</Icon>}
                                                            onClick={() => {
                                                                setExportDataPrimeiraParcela(acordoParcelasGeradas[0]?.vencimento || new Date().toISOString().substring(0, 10));
                                                                setOpenExportCronogramaModal(true);
                                                            }}
                                                        >
                                                            Exportar Modelo
                                                        </MDButton>
                                                    )}
                                                </MDBox>
                                            </MDBox>

                                            {acordoParcelasGeradas.length > 0 ? (
                                                <TableContainer component={Paper} variant="outlined" sx={{ boxShadow: "none", maxHeight: 280, border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0" }}>
                                                    <Table size="small" stickyHeader>
                                                        <TableHead sx={{ display: "table-header-group" }}>
                                                            <TableRow>
                                                                <TableCell><MDTypography variant="caption" color="text" fontWeight="medium">Nº</MDTypography></TableCell>
                                                                <TableCell><MDTypography variant="caption" color="text" fontWeight="medium">Tipo</MDTypography></TableCell>
                                                                <TableCell><MDTypography variant="caption" color="text" fontWeight="medium">Vencimento</MDTypography></TableCell>
                                                                <TableCell><MDTypography variant="caption" color="text" fontWeight="medium">Valor</MDTypography></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {acordoParcelasGeradas.map((p, pIdx) => (
                                                                <TableRow key={pIdx}>
                                                                    <TableCell><MDTypography variant="caption">{p.numeroParcela}</MDTypography></TableCell>
                                                                    <TableCell><MDTypography variant="caption" color={p.isEntrada ? "success" : "text"}>{p.isEntrada ? (p.isMle ? "Entrada (MLE)" : "Entrada") : "Parcela"}</MDTypography></TableCell>
                                                                    <TableCell>
                                                                        <MDInput
                                                                            type="date"
                                                                            size="small"
                                                                            value={p.vencimento}
                                                                            onChange={(e) => handleChangeParcela(pIdx, 'vencimento', e.target.value)}
                                                                            sx={{ minWidth: 130 }}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <MDInput
                                                                            type="text"
                                                                            size="small"
                                                                            value={typeof p.valorParcela === 'number' ? formatCurrencyInput(p.valorParcela) : p.valorParcela}
                                                                            onChange={(e) => handleChangeParcela(pIdx, 'valorParcela', formatCurrencyInput(e.target.value))}
                                                                            sx={{ minWidth: 120 }}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            ) : (
                                                <MDBox p={2} textAlign="center" borderRadius="md" sx={{ backgroundColor: darkMode ? "#424550" : "#f8f9fa", border: darkMode ? "1px dashed #606472" : "1px dashed #cfd8dc" }}>
                                                    <MDTypography variant="caption" color="text">
                                                        Clique em <b>Calcular Parcelas</b> para simular o cronograma de vencimentos e valores de cada parcela.
                                                    </MDTypography>
                                                </MDBox>
                                            )}
                                        </MDBox>
                                    </Grid>
                                )}

                                {/* Seção Honorários Advocatícios (se aplicável) */}
                                {!isHonorariosTab && (() => {
                                    const allowsHO = contratos.some(c => (selectedContratos.length === 0 || selectedContratos.includes(c.id)) && c.permiteGerarHonorario);
                                    if (!allowsHO) return null;
                                    return (
                                        <Grid item xs={12}>
                                            <MDBox p={2} borderRadius="lg" sx={{ backgroundColor: darkMode ? "#424550" : "#ffffff", border: darkMode ? "1px solid #606472" : "1px solid #e2e8f0" }}>
                                                <FormControlLabel
                                                    control={<Switch checked={gerarHO} onChange={(e) => setGerarHO(e.target.checked)} color="info" />}
                                                    label={<MDTypography variant="button" fontWeight="medium" color={darkMode ? "white" : "dark"}>Gerar Dívida de Honorários Advocatícios sobre o Acordo?</MDTypography>}
                                                />
                                                {gerarHO && (
                                                    <Grid container spacing={2} mt={1}>
                                                        <Grid item xs={12} sm={6}>
                                                            <MDInput
                                                                type="number"
                                                                label="Percentual (%) sobre o Acordo"
                                                                value={hoPercentual}
                                                                onChange={(e) => setHoPercentual(e.target.value)}
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <MDInput select label="Tipo de Honorário" value={hoTipo} onChange={(e) => setHoTipo(e.target.value)} fullWidth InputLabelProps={{ shrink: true }}>
                                                                {hoTiposList.map((t) => (
                                                                    <MenuItem key={t.id} value={t.id}>
                                                                        {t.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </MDInput>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </MDBox>
                                        </Grid>
                                    );
                                })()}
                            </Grid>
                        );
                    })()}
                </DialogContent>
                <DialogActions sx={{ p: 2, backgroundColor: darkMode ? "#4B4F5C" : "#ffffff", borderTop: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #f0f2f5" }}>
                    <MDButton
                        variant="outlined"
                        color={darkMode ? "white" : "secondary"}
                        onClick={() => { setAcordoModalOpen(false); setAcordoMinimizado(false); }}
                        sx={{ px: 3 }}
                    >
                        Cancelar
                    </MDButton>
                    <MDButton
                        variant="contained"
                        color="info"
                        onClick={handleGerarAcordo}
                        disabled={acordoLoading || isBloqueadoPorRegra || (!isAvistaAcordo && (!cronogramaCalculado || acordoParcelasGeradas.length === 0))}
                        startIcon={<Icon>check</Icon>}
                        sx={{ px: 3, fontWeight: "bold" }}
                    >
                        Confirmar e Gerar
                    </MDButton>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
                <DialogTitle>Confirmar Exclusão</DialogTitle>
                <DialogContent>
                    Tem certeza que deseja excluir o contrato <strong>{contratoToDelete?.titulo}</strong>?
                    <br /><br />
                    <MDTypography variant="caption" color="error">
                        Atenção: Esta ação não poderá ser desfeita e pode afetar acordos vinculados.
                    </MDTypography>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setDeleteDialogOpen(false)} color={darkMode ? "white" : "secondary"}>
                        Cancelar
                    </MDButton>
                    <MDButton onClick={confirmDelete} color="error" variant="contained">
                        Excluir
                    </MDButton>
                </DialogActions>
            </Dialog>

            <MDSnackbar
                color="success"
                icon="check"
                title="Sucesso"
                content={sbMessage}
                open={successSB}
                onClose={() => setSuccessSB(false)}
                close={() => setSuccessSB(false)}
                bgWhite
            />
            <MDSnackbar
                color="error"
                icon="warning"
                title="Erro"
                content={sbMessage}
                open={errorSB}
                onClose={() => setErrorSB(false)}
                close={() => setErrorSB(false)}
                bgWhite
            />
            {/* Modal Confirmação Cancelamento */}
            <Dialog open={confirmCancelOpen} onClose={() => setConfirmCancelOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Atenção! Acordo Ativo Encontrado</DialogTitle>
                <DialogContent>
                    <MDTypography variant="body2" color="text">
                        Esta ficha já possui um Acordo Ativo. Deseja iniciar uma nova simulação?<br /><br />
                        <b>Nota:</b> O acordo atual só será efetivamente cancelado no sistema quando você finalizar a nova negociação clicando em "Confirmar e Gerar".
                    </MDTypography>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setConfirmCancelOpen(false)} color="secondary">Voltar</MDButton>
                    <MDButton onClick={() => {
                        setConfirmCancelOpen(false);
                        if (pendingOpcao && pendingOpcao.isManual) {
                            proceedOpenAcordoManual();
                        } else {
                            proceedOpenAcordoModal(pendingOpcao);
                        }
                    }} color="info">Continuar e Simular Novo</MDButton>
                </DialogActions>
            </Dialog>

            {/* Migração / Devolução Modal */}
            <Dialog open={migracaoModalOpen} onClose={() => setMigracaoModalOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {tipoSolicitacao === "MIGRACAO"
                        ? (isDirectMigrateUser ? "Migrar Contratos Selecionados" : "Solicitar Migração de Carteira (Fila do Suporte)")
                        : (isDirectMigrateUser ? "Devolver Ficha / Contrato" : "Solicitar Devolução (Fila do Suporte)")
                    }
                </DialogTitle>
                <DialogContent>
                    <MDBox display="flex" gap={1.5} mb={2.5} mt={0.5}>
                        <MDButton
                            variant={tipoSolicitacao === "MIGRACAO" ? "gradient" : "outlined"}
                            color="info"
                            size="small"
                            fullWidth
                            onClick={() => setTipoSolicitacao("MIGRACAO")}
                        >
                            <Icon sx={{ mr: 0.5 }}>autorenew</Icon> Migração de Carteira
                        </MDButton>
                        <MDButton
                            variant={tipoSolicitacao === "DEVOLUCAO" ? "gradient" : "outlined"}
                            color="warning"
                            size="small"
                            fullWidth
                            onClick={() => setTipoSolicitacao("DEVOLUCAO")}
                        >
                            <Icon sx={{ mr: 0.5 }}>assignment_return</Icon> Devolução
                        </MDButton>
                    </MDBox>

                    {tipoSolicitacao === "MIGRACAO" ? (
                        <>
                            <MDTypography variant="body2" color="text" mb={2}>
                                {!isDirectMigrateUser
                                    ? "Preencha a carteira de destino para enviar a solicitação à Fila do Suporte:"
                                    : contratosFiltrados.length === 1
                                        ? "Selecione as opções de destino para a ficha:"
                                        : (selectedContratos.length > 0 && selectedContratos.length < contratosFiltrados.length)
                                            ? `Selecione as opções de destino do(s) ${selectedContratos.length} contrato(s) selecionado(s):`
                                            : `Selecione as opções de destino para todos os ${contratosFiltrados.length} contratos:`
                                }
                            </MDTypography>
                            <MDInput
                                select
                                fullWidth
                                label="Carteira de Destino *"
                                value={selectedCarteiraMigracao}
                                onChange={(e) => setSelectedCarteiraMigracao(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                sx={{ mb: 2 }}
                            >
                                <MenuItem value="">Selecione...</MenuItem>
                                {carteirasMigracaoOptions.map((c, i) => (
                                    <MenuItem key={i} value={c.id || c.cvId}>{c.nome || c.ccNome}</MenuItem>
                                ))}
                            </MDInput>

                            {isDirectMigrateUser && (
                                <>
                                    <MDInput
                                        select
                                        fullWidth
                                        label="Proprietário da Ficha (Opcional)"
                                        value={selectedUsuarioMigracao}
                                        onChange={(e) => setSelectedUsuarioMigracao(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{ mb: 2 }}
                                    >
                                        <MenuItem value="">Nenhum</MenuItem>
                                        {usuariosOptions.map((c, i) => (
                                            <MenuItem key={i} value={c.id || c.cvId}>{c.nome || c.ccNome}</MenuItem>
                                        ))}
                                    </MDInput>
                                    <MDInput
                                        select
                                        fullWidth
                                        label="Status da Ficha (Opcional)"
                                        value={selectedStatusMigracao}
                                        onChange={(e) => setSelectedStatusMigracao(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{ mb: 2 }}
                                    >
                                        <MenuItem value="">Em aberto (Padrão)</MenuItem>
                                        {statusFichaOptions.map((c, i) => (
                                            <MenuItem key={i} value={c.id || c.cvId}>{c.nome || c.ccNome}</MenuItem>
                                        ))}
                                    </MDInput>
                                </>
                            )}
                        </>
                    ) : (
                        <MDBox mb={2}>
                            <MDBox
                                p={1.5}
                                mb={2}
                                sx={{
                                    borderRadius: "8px",
                                    bgcolor: darkMode ? "#4a3b1a" : "#fff8e1",
                                    border: `1px solid ${darkMode ? "#ffa000" : "#ffe082"}`
                                }}
                            >
                                <MDTypography variant="caption" fontWeight="bold" sx={{ color: darkMode ? "#ffb74d" : "#e65100", display: "block" }}>
                                    {selectedContratos.length > 0 && selectedContratos.length < contratosFiltrados.length
                                        ? `Atenção: A devolução será aplicada para ${selectedContratos.length} contrato(s) selecionado(s).`
                                        : `Atenção: A devolução será solicitada para toda a ficha do devedor (${contratosFiltrados.length} contrato(s)).`
                                    }
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                    )}

                    <MDBox mb={2}>
                        <MDTypography variant="caption" color="text" fontWeight="medium" display="block" mb={0.8}>
                            Anexar Documento / Comprovante (Opcional):
                        </MDTypography>
                        <MDBox display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
                            <Button
                                variant="outlined"
                                component="label"
                                size="small"
                                sx={{
                                    borderColor: darkMode ? "rgba(255,255,255,0.25)" : "#ccc",
                                    color: darkMode ? "#fff" : "inherit",
                                    fontSize: "0.75rem",
                                    textTransform: "none"
                                }}
                            >
                                <Icon sx={{ mr: 0.5, fontSize: "18px !important" }}>attach_file</Icon>
                                {migracaoFile ? "Substituir Arquivo" : "Escolher Arquivo"}
                                <input
                                    type="file"
                                    hidden
                                    onChange={(e) => setMigracaoFile(e.target.files[0] || null)}
                                />
                            </Button>
                            {migracaoFile && (
                                <Chip
                                    label={migracaoFile.name}
                                    onDelete={() => setMigracaoFile(null)}
                                    size="small"
                                    color="info"
                                    sx={{ maxWidth: "250px" }}
                                />
                            )}
                        </MDBox>
                    </MDBox>

                    <MDInput
                        fullWidth
                        multiline
                        rows={3}
                        label={tipoSolicitacao === "MIGRACAO" ? "Observação para o Suporte" : "Motivo da Devolução *"}
                        placeholder={tipoSolicitacao === "MIGRACAO" ? "Descreva a justificativa ou necessidade da migração..." : "Informe o motivo detalhado da devolução..."}
                        value={observacaoMigracao}
                        onChange={(e) => setObservacaoMigracao(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        required={tipoSolicitacao === "DEVOLUCAO"}
                    />
                </DialogContent>
                <DialogActions>
                    <MDButton color="secondary" onClick={() => setMigracaoModalOpen(false)}>Cancelar</MDButton>
                    <MDButton color={tipoSolicitacao === "MIGRACAO" ? "info" : "warning"} onClick={handleConfirmMigracao}>
                        {tipoSolicitacao === "MIGRACAO"
                            ? (isDirectMigrateUser ? "Migrar" : "Enviar Solicitação")
                            : (isDirectMigrateUser ? "Devolver Diretamente" : "Enviar Solicitação")
                        }
                    </MDButton>
                </DialogActions>
            </Dialog>

            {!isViewOnly && formRef && (
                <Grid container spacing={3} mt={2}>
                    <Grid item xs={12} display="flex" justifyContent="flex-end">
                        <MDButton variant="gradient" color="info" disabled={isSavingForm || formRef.current?.isSubmitting} onClick={async () => {
                            if (formRef.current) {
                                setIsSavingForm(true);
                                const errors = await formRef.current.validateForm();
                                if (Object.keys(errors).length > 0) {
                                    formRef.current.setTouched(
                                        Object.keys(errors).reduce((acc, curr) => ({ ...acc, [curr]: true }), {})
                                    );
                                    alert("Existem campos obrigatórios na aba Cadastro Básico que não foram preenchidos.");
                                    setIsSavingForm(false);
                                    return;
                                }
                                formRef.current.submitForm().finally(() => setIsSavingForm(false));
                            }
                        }}>
                            Salvar Cadastro
                        </MDButton>
                    </Grid>
                </Grid>
            )}
            {/* Devolução Modal */}
            <Dialog open={openDevolverModal} onClose={() => !isSubmittingDevolucao && setOpenDevolverModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Solicitar Devolução de Contrato/Título</DialogTitle>
                <DialogContent>
                    <MDBox mt={2}>
                        <MDTypography variant="body2" color="text" mb={2}>
                            <strong>Contrato:</strong> {contratoParaDevolver?.titulo || "-"}
                        </MDTypography>
                        <MDInput
                            label="Motivo / Observação"
                            multiline
                            rows={4}
                            fullWidth
                            value={devolverObs}
                            onChange={(e) => setDevolverObs(e.target.value)}
                            disabled={isSubmittingDevolucao}
                            required
                        />
                    </MDBox>
                    <MDBox mt={2}>
                        <MDTypography variant="caption" fontWeight="bold">Anexar Arquivo (Opcional)</MDTypography>
                        <input
                            type="file"
                            onChange={(e) => setDevolverFile(e.target.files[0])}
                            disabled={isSubmittingDevolucao}
                            style={{ display: "block", marginTop: "8px" }}
                        />
                    </MDBox>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setOpenDevolverModal(false)} color="secondary" disabled={isSubmittingDevolucao}>Cancelar</MDButton>
                    <MDButton
                        onClick={async () => {
                            if (!devolverObs) {
                                alert("Preencha o motivo/observação.");
                                return;
                            }
                            setIsSubmittingDevolucao(true);
                            try {
                                await postNoResponse(`/contratos/solicitar-devolucao/${contratoParaDevolver.id}`, { observacao: devolverObs });
                                if (devolverFile) {
                                    const formData = new FormData();
                                    formData.append("file", devolverFile);
                                    formData.append("devedorId", recordId);
                                    await postUploadNoResponse(`/documents/devedor/upload`, formData);
                                }
                                setOpenDevolverModal(false);
                                showSnackbar("Solicitação de devolução enviada com sucesso!", true);
                                setIsSubmittingDevolucao(false);
                                fetchContratos();
                            } catch (e) {
                                showSnackbar("Erro ao solicitar devolução do contrato.", false);
                                setIsSubmittingDevolucao(false);
                            }
                        }}
                        color="primary"
                        disabled={isSubmittingDevolucao}
                    >
                        {isSubmittingDevolucao ? "Enviando..." : "Enviar Solicitação"}
                    </MDButton>
                </DialogActions>
            </Dialog>

            <Dialog open={confirmAction.open} onClose={() => setConfirmAction({ ...confirmAction, open: false })} maxWidth="xs" fullWidth>
                <DialogTitle>{confirmAction.title}</DialogTitle>
                <DialogContent>
                    <MDTypography variant="body2">{confirmAction.message}</MDTypography>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => {
                        if (confirmAction.onCancel) confirmAction.onCancel();
                        setConfirmAction({ ...confirmAction, open: false });
                    }} color="secondary">{confirmAction.cancelText || "Cancelar"}</MDButton>
                    <MDButton onClick={() => {
                        if (confirmAction.onConfirm) confirmAction.onConfirm();
                        setConfirmAction({ ...confirmAction, open: false });
                    }} color={confirmAction.confirmColor || "info"}>{confirmAction.confirmText || "OK"}</MDButton>
                </DialogActions>
            </Dialog>

            <Dialog open={openExportCronogramaModal} onClose={() => setOpenExportCronogramaModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Exportar Cronograma (Amostra)</DialogTitle>
                <DialogContent>
                    <MDBox mt={2} mb={2}>
                        <MDTypography variant="body2" mb={2}>
                            Selecione a data da primeira parcela. As demais datas serão refletidas sequencialmente de acordo com a periodicidade ({acordoPeriodicidade} dias), mas os valores continuarão sendo exatamente os da simulação atual.
                        </MDTypography>
                        <MDInput
                            type="date"
                            label="Data da 1ª Parcela"
                            value={exportDataPrimeiraParcela}
                            onChange={(e) => setExportDataPrimeiraParcela(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </MDBox>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setOpenExportCronogramaModal(false)} color="secondary">Cancelar</MDButton>
                    <MDButton
                        color="info"
                        onClick={() => {
                            if (!acordoParcelasGeradas || acordoParcelasGeradas.length === 0) return;

                            const startDateStr = exportDataPrimeiraParcela;
                            let currentMoment = moment(startDateStr);

                            const exportParcelas = acordoParcelasGeradas.map((p, idx) => {
                                let pDateStr = currentMoment.format("DD/MM/YYYY");

                                if (acordoPeriodicidade == 30) {
                                    currentMoment.add(1, 'month');
                                } else {
                                    currentMoment.add(acordoPeriodicidade || 30, 'days');
                                }

                                return {
                                    ...p,
                                    vencimentoExport: pDateStr
                                };
                            });

                            const printWindow = window.open('', '', 'width=900,height=750');
                            if (!printWindow) {
                                window.print();
                                setOpenExportCronogramaModal(false);
                                return;
                            }

                            const rowsHtml = exportParcelas.map((p) => {
                                const tipoStr = p.isEntrada ? (p.isMle ? "Entrada (MLE)" : "Entrada") : "Parcela";
                                const valStr = typeof p.valorParcela === 'number' ? toCurrency(p.valorParcela) : (String(p.valorParcela).includes('R$') ? String(p.valorParcela) : 'R$ ' + String(p.valorParcela));
                                return `
                                    <tr>
                                        <td style="padding: 8px 12px; border: 1px solid #000; text-align: center;">${p.numeroParcela}</td>
                                        <td style="padding: 8px 12px; border: 1px solid #000; text-align: left;">${tipoStr}</td>
                                        <td style="padding: 8px 12px; border: 1px solid #000; text-align: center;">${p.vencimentoExport}</td>
                                        <td style="padding: 8px 12px; border: 1px solid #000; text-align: right;">${valStr}</td>
                                    </tr>
                                `;
                            }).join('');

                            printWindow.document.write(`
                                <!DOCTYPE html>
                                <html>
                                <head>
                                    <meta charset="utf-8" />
                                    <title>Cronograma de Pagamento</title>
                                    <style>
                                        @page { size: auto; margin: 0; }
                                        * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; color-adjust: exact !important; }
                                        html, body { background: #fff !important; margin: 0 !important; padding: 15mm 20mm !important; box-sizing: border-box; }
                                        body { font-family: 'Roboto', 'Calibri', 'Segoe UI', Helvetica, Arial, sans-serif; color: #000; }
                                        h2 { text-align: center; margin-bottom: 20px; }
                                        table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 14px; border: 1px solid #000; }
                                        th { background-color: #f0f0f0 !important; color: #000 !important; font-weight: bold; padding: 8px 12px; border: 1px solid #000; text-align: center; }
                                        td { border: 1px solid #000; padding: 8px 12px; }
                                    </style>
                                </head>
                                <body>
                                    <h2>Cronograma de Pagamento (Amostra)</h2>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Nº</th>
                                                <th>Tipo</th>
                                                <th>Vencimento</th>
                                                <th>Valor</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            ${rowsHtml}
                                        </tbody>
                                    </table>
                                </body>
                                </html>
                            `);
                            printWindow.document.close();
                            setOpenExportCronogramaModal(false);
                        }}
                    >
                        Confirmar e Exportar
                    </MDButton>
                </DialogActions>
            </Dialog>

            {/* Modal de Reagrupamento de Débitos */}
            <Dialog 
                open={reagruparModalOpen} 
                onClose={() => !isSubmittingReagrupamento && setReagruparModalOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        bgcolor: darkMode ? "#424550" : "#ffffff",
                        borderRadius: "12px",
                        border: darkMode ? "1px solid rgba(255,255,255,0.15)" : "1px solid #e0e0e0",
                        boxShadow: darkMode ? "0 8px 32px rgba(0,0,0,0.5)" : "0 8px 32px rgba(0,0,0,0.12)",
                        overflow: "hidden"
                    }
                }}
            >
                <DialogTitle sx={{ 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "space-between",
                    py: 1.8, 
                    px: 2.5,
                    borderBottom: `1px solid ${darkMode ? "rgba(255,255,255,0.1)" : "#f0f2f5"}`,
                    bgcolor: darkMode ? "#4B4F5C" : "#f8f9fa"
                }}>
                    <MDBox display="flex" alignItems="center" gap={1.2}>
                        <MDBox 
                            sx={{ 
                                width: 32, 
                                height: 32, 
                                borderRadius: "8px", 
                                bgcolor: darkMode ? "rgba(33, 150, 243, 0.2)" : "#e3f2fd", 
                                display: "flex", 
                                alignItems: "center", 
                                justifyContent: "center" 
                            }}
                        >
                            <Icon sx={{ color: "#2196f3", fontSize: "20px !important" }}>merge</Icon>
                        </MDBox>
                        <MDTypography variant="h6" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                            Reagrupar Débitos entre Fichas
                        </MDTypography>
                    </MDBox>
                    <IconButton 
                        size="small" 
                        onClick={() => !isSubmittingReagrupamento && setReagruparModalOpen(false)}
                        sx={{ color: darkMode ? "rgba(255,255,255,0.7)" : "#777" }}
                    >
                        <Icon fontSize="small">close</Icon>
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ p: 2.5, borderColor: darkMode ? "rgba(255,255,255,0.1)" : "#f0f2f5" }}>
                    {/* Ficha de Origem */}
                    <MDBox mb={2.5}>
                        <MDTypography variant="caption" fontWeight="bold" sx={{ color: darkMode ? "rgba(255,255,255,0.75)" : "#555", textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "0.72rem", mb: 0.8, display: "block" }}>
                            Ficha de Origem (Atual)
                        </MDTypography>
                        <MDBox 
                            p={1.5} 
                            sx={{ 
                                bgcolor: darkMode ? "#4B4F5C" : "#f8f9fa", 
                                borderRadius: "8px",
                                border: `1px solid ${darkMode ? "rgba(255,255,255,0.15)" : "#e0e0e0"}`,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                gap: 1
                            }}
                        >
                            <MDBox display="flex" alignItems="center" gap={1}>
                                <Chip 
                                    label={`Ficha #${selectedFicha?.rawId || selectedFicha?.id || "-"}`} 
                                    size="small" 
                                    color="info" 
                                    sx={{ fontWeight: "bold", fontSize: "11px", height: "22px" }} 
                                />
                                <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                    {selectedFicha?.nomeCarteira || "Carteira Principal"}
                                </MDTypography>
                            </MDBox>
                            <Chip 
                                icon={<Icon fontSize="small" sx={{ color: "inherit !important" }}>receipt_long</Icon>}
                                label={`${contratosFiltrados.length} ${contratosFiltrados.length === 1 ? "débito" : "débitos"}`} 
                                size="small" 
                                variant="outlined"
                                color={darkMode ? "secondary" : "default"}
                                sx={{ fontWeight: "medium", fontSize: "11px", height: "22px" }}
                            />
                        </MDBox>
                    </MDBox>

                    {/* Ficha de Destino */}
                    <MDBox mb={2.5}>
                        <MDTypography variant="caption" fontWeight="bold" sx={{ color: darkMode ? "rgba(255,255,255,0.75)" : "#555", textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "0.72rem", mb: 0.8, display: "block" }}>
                            Ficha de Destino (para onde os débitos irão)
                        </MDTypography>
                        {fichasDisponiveis.length === 0 ? (
                            <MDBox p={1.5} sx={{ bgcolor: darkMode ? "#4a2525" : "#ffebee", borderRadius: "8px", border: "1px solid #ef5350" }}>
                                <MDTypography variant="caption" color="error" fontWeight="medium">
                                    Este devedor não possui outra ficha cadastrada para onde transferir os débitos.
                                </MDTypography>
                            </MDBox>
                        ) : (
                            <MDSelect
                                isMulti={false}
                                getOptionValue={(o) => o.rawId || o.id}
                                getOptionLabel={(o) => `[Ficha #${o.rawId || o.id}] ${o.nomeCarteira || (o.isHonorario ? 'Honorários' : 'Carteira')} (${o.situacao === 1 ? 'Devolvida' : (o.situacao === 7 ? 'Quitada' : 'Ativa')})`}
                                placeholder="Selecione a ficha de destino..."
                                value={fichasDisponiveis.find(f => String(f.rawId || f.id) === String(reagruparDestinoId)) || null}
                                options={fichasDisponiveis}
                                onChange={(val) => setReagruparDestinoId(val ? (val.rawId || val.id) : "")}
                            />
                        )}
                    </MDBox>

                    {/* Escopo da Transferência */}
                    <MDBox mb={2.5}>
                        <MDTypography variant="caption" fontWeight="bold" sx={{ color: darkMode ? "rgba(255,255,255,0.75)" : "#555", textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "0.72rem", mb: 0.8, display: "block" }}>
                            Escopo da Transferência
                        </MDTypography>
                        <MDBox display="flex" flexDirection="column" gap={1.2}>
                            {/* Opção 1: Todos */}
                            <MDBox
                                onClick={() => setReagruparMoverTodos(true)}
                                p={1.5}
                                borderRadius="8px"
                                sx={{
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    bgcolor: reagruparMoverTodos ? (darkMode ? "#4B4F5C" : "#e3f2fd") : (darkMode ? "#383c48" : "#f8f9fa"),
                                    border: reagruparMoverTodos 
                                        ? "2px solid #1976d2" 
                                        : `1px solid ${darkMode ? "rgba(255,255,255,0.12)" : "#e0e0e0"}`,
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 1.2
                                }}
                            >
                                <Radio
                                    checked={reagruparMoverTodos}
                                    onChange={() => setReagruparMoverTodos(true)}
                                    color="info"
                                    sx={{ p: 0, mt: 0.2 }}
                                />
                                <MDBox display="flex" flexDirection="column" gap={0.3}>
                                    <MDTypography variant="button" fontWeight="bold" color={reagruparMoverTodos ? "info" : (darkMode ? "white" : "dark")}>
                                        Mover TODOS os débitos desta ficha ({contratosFiltrados.length})
                                    </MDTypography>
                                    <MDTypography variant="caption" color="text" sx={{ fontSize: "0.75rem", lineHeight: 1.4 }}>
                                        <strong>Consolidação total:</strong> migrará contratos, acordos, históricos e dados de processos. A ficha de origem será <strong>eliminada</strong> sem pendências relacionais.
                                    </MDTypography>
                                </MDBox>
                            </MDBox>

                            {/* Opção 2: Parcial */}
                            <MDBox
                                onClick={() => {
                                    if (selectedContratos.length > 0) setReagruparMoverTodos(false);
                                }}
                                p={1.5}
                                borderRadius="8px"
                                sx={{
                                    cursor: selectedContratos.length > 0 ? "pointer" : "not-allowed",
                                    opacity: selectedContratos.length > 0 ? 1 : 0.6,
                                    transition: "all 0.2s ease",
                                    bgcolor: !reagruparMoverTodos ? (darkMode ? "#4B4F5C" : "#e3f2fd") : (darkMode ? "#383c48" : "#f8f9fa"),
                                    border: !reagruparMoverTodos 
                                        ? "2px solid #1976d2" 
                                        : `1px solid ${darkMode ? "rgba(255,255,255,0.12)" : "#e0e0e0"}`,
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 1.2
                                }}
                            >
                                <Radio
                                    checked={!reagruparMoverTodos}
                                    onChange={() => {
                                        if (selectedContratos.length > 0) setReagruparMoverTodos(false);
                                    }}
                                    disabled={selectedContratos.length === 0}
                                    color="info"
                                    sx={{ p: 0, mt: 0.2 }}
                                />
                                <MDBox display="flex" flexDirection="column" gap={0.3}>
                                    <MDTypography variant="button" fontWeight="bold" color={!reagruparMoverTodos ? "info" : (selectedContratos.length === 0 ? "secondary" : (darkMode ? "white" : "dark"))}>
                                        Mover apenas os {selectedContratos.length} débito(s) selecionado(s)
                                    </MDTypography>
                                    <MDTypography variant="caption" color="text" sx={{ fontSize: "0.75rem", lineHeight: 1.4 }}>
                                        {selectedContratos.length === 0
                                            ? "(Nenhum débito marcado na tabela. Para usar esta opção, selecione as checkboxes da tabela de contratos)."
                                            : "<strong>Migração parcial:</strong> apenas os débitos selecionados migrarão, e esta ficha continuará ativa com os demais débitos."}
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                        </MDBox>
                    </MDBox>

                    {/* Motivo / Justificativa */}
                    <MDBox mb={1}>
                        <MDTypography variant="caption" fontWeight="bold" sx={{ color: darkMode ? "rgba(255,255,255,0.75)" : "#555", textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "0.72rem", mb: 0.8, display: "block" }}>
                            Motivo / Justificativa (Opcional)
                        </MDTypography>
                        <MDInput
                            placeholder="Ex: Correção de migração legada duplicada por engano"
                            value={reagruparMotivo}
                            onChange={(e) => setReagruparMotivo(e.target.value)}
                            multiline
                            rows={2}
                            fullWidth
                        />
                    </MDBox>
                </DialogContent>

                <DialogActions sx={{ 
                    p: 2, 
                    px: 2.5,
                    borderTop: `1px solid ${darkMode ? "rgba(255,255,255,0.1)" : "#f0f2f5"}`,
                    bgcolor: darkMode ? "#4B4F5C" : "#f8f9fa",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1
                }}>
                    <MDButton 
                        variant="outlined" 
                        color={darkMode ? "white" : "secondary"} 
                        size="small" 
                        onClick={() => setReagruparModalOpen(false)} 
                        disabled={isSubmittingReagrupamento}
                    >
                        Cancelar
                    </MDButton>
                    <MDButton
                        variant="gradient"
                        color="info"
                        size="small"
                        disabled={isSubmittingReagrupamento || !reagruparDestinoId || fichasDisponiveis.length === 0 || (!reagruparMoverTodos && selectedContratos.length === 0)}
                        onClick={handleConfirmReagrupar}
                    >
                        {isSubmittingReagrupamento ? (
                            <CircularProgress size={18} color="inherit" />
                        ) : (
                            <>
                                <Icon sx={{ mr: 0.5 }}>merge</Icon>
                                Confirmar Reagrupamento
                            </>
                        )}
                    </MDButton>
                </DialogActions>
            </Dialog>
        </MDBox>
    );
}
